const landuseCodesData = { "AA/RAC Service Centres and Boxes": {
        SCAT: { code: "1", description: "AA/RAC Service Centres and Boxes" },
        CPA: { code: "95.31", description: "Repair and maintenance services of motor vehicles" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9531", description: "Repair and maintenance of motor vehicles" },
        NACE_level_4: { code: "95.31", description: "Repair and maintenance of motor vehicles" },
        NACE_level_3: { code: "95.3", description: "Repair and maintenance of motor vehicles and motorcycles" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "95.29", description: "Repair of other personal and household goods" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Advertising Right": {
        SCAT: { code: "3", description: "Advertising Right" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "N/A", description: "" },
    },
    "Agricultural Showgrounds (National Scheme)": {
        SCAT: { code: "4", description: "Agricultural Showgrounds (National Scheme)" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "82.30", description: "Organisation of conventions and trade shows" },
        planning_classes: { code: "", description: "" },
    },
    "Air Ports (Minor) (National Scheme)": {
        SCAT: { code: "5", description: "Air Ports (Minor) (National Scheme)" },
        CPA: { code: "52.23", description: "Services incidental to air transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5223", description: "Service activities incidental to air transportation" },
        NACE_level_4: { code: "52.23", description: "Service activities incidental to air transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.23", description: "Service activities incidental to air transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Air Strips (National Scheme)": {
        SCAT: { code: "6", description: "Air Strips (National Scheme)" },
        CPA: { code: "52.23", description: "Services incidental to air transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5223", description: "Service activities incidental to air transportation" },
        NACE_level_4: { code: "52.23", description: "Service activities incidental to air transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.23", description: "Service activities incidental to air transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Aircraft Works With Airfields": {
        SCAT: { code: "7", description: "Aircraft Works With Airfields" },
        CPA: { code: "30.31", description: "Civilian air and spacecraft and related machinery" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3030", description: "Manufacture of air and spacecraft and related machinery" },
        NACE_level_4: { code: "30.31", description: "Manufacture of civilian air and spacecraft and related machinery" },
        NACE_level_3: { code: "30.3", description: "Manufacture of air and spacecraft and related machinery" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "30.30", description: "Manufacture of air and spacecraft and related machinery" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Airport Let Outs": {
        SCAT: { code: "8", description: "Airport Let Outs" },
        CPA: { code: "52.23", description: "Services incidental to air transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5223", description: "Service activities incidental to air transportation" },
        NACE_level_4: { code: "52.23", description: "Service activities incidental to air transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.23", description: "Service activities incidental to air transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Aluminum Smelting Works": {
        SCAT: { code: "9", description: "Aluminum Smelting Works" },
        CPA: { code: "24.42", description: "Aluminium" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "24.42", description: "Aluminium production" },
        NACE_level_3: { code: "24.4", description: "Manufacture of basic precious and other non-ferrous metals" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "24.42", description: "Aluminium production" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Ambulance Stations": {
        SCAT: { code: "10", description: "Ambulance Stations" },
        CPA: { code: "84.24", description: "Public order and safety services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.24", description: "Public order and safety activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.24", description: "Public order and safety activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Amusement Arcades": {
        SCAT: { code: "11", description: "Amusement Arcades" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "potato" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Amusement Parks": {
        SCAT: { code: "12", description: "Amusement Parks" },
        CPA: { code: "93.21", description: "Amusement park and theme park services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9321", description: "Activities of amusement parks and theme parks" },
        NACE_level_4: { code: "93.21", description: "Activities of amusement parks and theme parks" },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.21", description: "Activities of amusement parks and theme parks" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Animal Boarding": {
        SCAT: { code: "13", description: "Animal Boarding" },
        CPA: { code: "75.00", description: "Veterinary services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7500", description: "Veterinary activities" },
        NACE_level_4: { code: "75.00", description: "Veterinary activities" },
        NACE_level_3: { code: "75.0", description: "Veterinary activities" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "75.00", description: "Veterinary activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Arenas": {
        SCAT: { code: "14", description: "Arenas" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Army Hereditaments": {
        SCAT: { code: "15", description: "Army Hereditaments" },
        CPA: { code: "84.22", description: "Defence services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8422", description: "Defence activities" },
        NACE_level_4: { code: "84.22", description: "Defence activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.22", description: "Defence activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Artificial Fibre Works": {
        SCAT: { code: "16", description: "Artificial Fibre Works" },
        CPA: { code: "20.60", description: "Man-made fibres" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2030", description: "Manufacture of man-made fibres" },
        NACE_level_4: { code: "20.60", description: "Manufacture of man-made fibres" },
        NACE_level_3: { code: "20.6", description: "Manufacture of man-made fibres" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "20.60", description: "Manufacture of man-made fibres" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Asphalt Plants": {
        SCAT: { code: "17", description: "Asphalt Plants" },
        CPA: { code: "23.64", description: "Mortars" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2395", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_4: { code: "23.64", description: "Manufacture of mortars" },
        NACE_level_3: { code: "23.6", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.64", description: "Manufacture of mortars" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "ATMs": {
        SCAT: { code: "18", description: "ATMs" },
        CPA: { code: "64.19", description: "Other monetary intermediation services" },
        ISIC_level_1: { code: "L", description: "Financial and Insurance activities" },
        ISIC_level_4: { code: "6419", description: "Other monetary intermediation" },
        NACE_level_4: { code: "64.19", description: "Other monetary intermediation" },
        NACE_level_3: { code: "64.1", description: "Monetary intermediation" },
        NACE_level_1: { code: "L", description: "Financial and Insurance activities" },
        UK_SIC: { code: "64.19", description: "Other monetary intermediation" },
        planning_classes: { code: "N/A", description: "" },
    },
    "Auction Rooms": {
        SCAT: { code: "19", description: "Auction Rooms" },
        CPA: { code: "47.79", description: "Retail sale services of second-hand goods, except motor vehicles and motorcycles" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4774", description: "Retail sale of second-hand goods" },
        NACE_level_4: { code: "47.79", description: "Retail sale of second-hand goods" },
        NACE_level_3: { code: "47.7", description: "Retail sale of other goods, except motor vehicles and motorcycles" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.79", description: "Retail sale of second-hand goods in stores" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Baling Plants": {
        SCAT: { code: "20", description: "Baling Plants" },
        CPA: { code: "01.30", description: "Planting material: live plants, bulbs, tubers and roots, cuttings and slips; mushroom spawn" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0130", description: "Plant propagation" },
        NACE_level_4: { code: "01.30", description: "Plant propagation" },
        NACE_level_3: { code: "01.3", description: "Plant propagation" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.30", description: "Plant propagation" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Banks/Insurance/Building Society Offices & Other A2 Uses": {
        SCAT: { code: "21", description: "Banks/Insurance/Building Society Offices & Other A2 Uses" },
        CPA: { code: "64.11", description: "Central banking services" },
        ISIC_level_1: { code: "L", description: "Financial and Insurance activities" },
        ISIC_level_4: { code: "6411", description: "Central banking" },
        NACE_level_4: { code: "64.11", description: "Central banking" },
        NACE_level_3: { code: "64.1", description: "Monetary intermediation" },
        NACE_level_1: { code: "L", description: "Financial and Insurance activities" },
        UK_SIC: { code: "64.11", description: "Central banking" },
        planning_classes: { code: "E(c)(i)", description: "Financial services" },
    },
    "Beach Huts": {
        SCAT: { code: "22", description: "Beach Huts" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Beet Sugar Factories": {
        SCAT: { code: "23", description: "Beet Sugar Factories" },
        CPA: { code: "10.81", description: "Sugar" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1072", description: "Manufacture of sugar" },
        NACE_level_4: { code: "10.81", description: "Manufacture of sugar" },
        NACE_level_3: { code: "10.8", description: "Manufacture of other food products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.81", description: "Manufacture of sugar" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Betting Offices": {
        SCAT: { code: "24", description: "Betting Offices" },
        CPA: { code: "92.00", description: "Gambling and betting services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9200", description: "Gambling and betting activities" },
        NACE_level_4: { code: "92.00", description: "Gambling and betting activities" },
        NACE_level_3: { code: "92.0", description: "Gambling and betting activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "92.00", description: "Gambling and betting activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Bingo Halls (National Scheme)": {
        SCAT: { code: "25", description: "Bingo Halls (National Scheme)" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Bird Sanctuaries": {
        SCAT: { code: "26", description: "Bird Sanctuaries" },
        CPA: { code: "91.42", description: "Nature reserve services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9142", description: "Nature reserve activities" },
        NACE_level_4: { code: "91.42", description: "Nature reserve activities" },
        NACE_level_3: { code: "91.4", description: "Botanical and zoological garden and nature reserve activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.04", description: "Botanical and zoological gardens and nature reserve activities" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "Boat Yards": {
        SCAT: { code: "27", description: "Boat Yards" },
        CPA: { code: "30.12", description: "Pleasure and sporting boats" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3012", description: "Building of pleasure and sporting boats" },
        NACE_level_4: { code: "30.12", description: "Building of pleasure and sporting boats" },
        NACE_level_3: { code: "30.1", description: "Building of ships and boats" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "30.12", description: "Building of pleasure and sporting boats" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Bowling Alleys": {
        SCAT: { code: "28", description: "Bowling Alleys" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Bowling Centres (Indoor)": {
        SCAT: { code: "29", description: "Bowling Centres (Indoor)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Bowling Greens (Outdoor)": {
        SCAT: { code: "30", description: "Bowling Greens (Outdoor)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Breweries (National Scheme)": {
        SCAT: { code: "31", description: "Breweries (National Scheme)" },
        CPA: { code: "11.05", description: "Beer and brewing dregs" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1105", description: "Manufacture of soft drinks; production of mineral waters and other bottled waters" },
        NACE_level_4: { code: "11.05", description: "Manufacture of beer" },
        NACE_level_3: { code: "11.0", description: "Manufacture of beverages" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "11.05", description: "Manufacture of beer" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Brickworks (Traditional), Clay Tile/Pipe Works": {
        SCAT: { code: "32", description: "Brickworks (Traditional), Clay Tile/Pipe Works" },
        CPA: { code: "23.32", description: "Bricks, tiles and construction products, in baked clay" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2392", description: "Manufacture of clay building materials" },
        NACE_level_4: { code: "23.32", description: "Manufacture of bricks, tiles and construction products, in baked clay" },
        NACE_level_3: { code: "23.3", description: "Manufacture of clay building materials" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.32", description: "Manufacture of bricks, tiles and construction products, in baked clay" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Bulk Cement Storage Depots": {
        SCAT: { code: "33", description: "Bulk Cement Storage Depots" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Bullion/Money Stores (National Scheme)": {
        SCAT: { code: "34", description: "Bullion/Money Stores (National Scheme)" },
        CPA: { code: "64.19", description: "Other monetary intermediation services" },
        ISIC_level_1: { code: "L", description: "Financial and Insurance activities" },
        ISIC_level_4: { code: "6419", description: "Other monetary intermediation" },
        NACE_level_4: { code: "64.19", description: "Other monetary intermediation" },
        NACE_level_3: { code: "64.1", description: "Monetary intermediation" },
        NACE_level_1: { code: "L", description: "Financial and Insurance activities" },
        UK_SIC: { code: "64.19", description: "Other monetary intermediation" },
        planning_classes: { code: "E(c)(i)", description: "Financial services" },
    },
    "Bus Garages": {
        SCAT: { code: "35", description: "Bus Garages" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Bus Stations": {
        SCAT: { code: "36", description: "Bus Stations" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Cable Head End Buildings": {
        SCAT: { code: "37", description: "Cable Head End Buildings" },
        CPA: { code: "61.10", description: "Wired, wireless, and satellite telecommunication services" },
        ISIC_level_1: { code: "K", description: "Telecommunications, computer programming, consultancy, computing infrastructure, and other information service activities" },
        ISIC_level_4: { code: "6110", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_4: { code: "61.10", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_3: { code: "61.1", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.10", description: "Wired telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Car Auction Buildings/Sites": {
        SCAT: { code: "38", description: "Car Auction Buildings/Sites" },
        CPA: { code: "47.81", description: "Retail sale services of motor vehicles" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4781", description: "Retail sale of motor vehicles" },
        NACE_level_4: { code: "47.81", description: "Retail sale of motor vehicles" },
        NACE_level_3: { code: "47.8", description: "Retail sale of motor vehicles, motorcycles and related parts and accessories" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.81", description: "Retail sale via stalls and markets of food, beverages and tobacco products" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Parks (Multi-Storey)": {
        SCAT: { code: "39", description: "Car Parks (Multi-Storey)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Parks (Surfaced Open)": {
        SCAT: { code: "40", description: "Car Parks (Surfaced Open)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Parks (Unsurfaced Open)": {
        SCAT: { code: "41", description: "Car Parks (Unsurfaced Open)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Showrooms": {
        SCAT: { code: "42", description: "Car Showrooms" },
        CPA: { code: "47.81", description: "Retail sale services of motor vehicles" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4781", description: "Retail sale of motor vehicles" },
        NACE_level_4: { code: "47.81", description: "Retail sale of motor vehicles" },
        NACE_level_3: { code: "47.8", description: "Retail sale of motor vehicles, motorcycles and related parts and accessories" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.81", description: "Retail sale via stalls and markets of food, beverages and tobacco products" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Spaces": {
        SCAT: { code: "43", description: "Car Spaces" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Supermarkets": {
        SCAT: { code: "44", description: "Car Supermarkets" },
        CPA: { code: "47.81", description: "Retail sale services of motor vehicles" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4781", description: "Retail sale of motor vehicles" },
        NACE_level_4: { code: "47.81", description: "Retail sale of motor vehicles" },
        NACE_level_3: { code: "47.8", description: "Retail sale of motor vehicles, motorcycles and related parts and accessories" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.81", description: "Retail sale via stalls and markets of food, beverages and tobacco products" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Washes (Stand Alone)": {
        SCAT: { code: "45", description: "Car Washes (Stand Alone)" },
        CPA: { code: "95.31", description: "Repair and maintenance services of motor vehicles" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9531", description: "Repair and maintenance of motor vehicles" },
        NACE_level_4: { code: "95.31", description: "Repair and maintenance of motor vehicles" },
        NACE_level_3: { code: "95.3", description: "Repair and maintenance of motor vehicles and motorcycles" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "95.29", description: "Repair of other personal and household goods" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Car/Caravan Sales/Display/Hiring Sites": {
        SCAT: { code: "46", description: "Car/Caravan Sales/Display/Hiring Sites" },
        CPA: { code: "47.81", description: "Retail sale services of motor vehicles" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4781", description: "Retail sale of motor vehicles" },
        NACE_level_4: { code: "47.81", description: "Retail sale of motor vehicles" },
        NACE_level_3: { code: "47.8", description: "Retail sale of motor vehicles, motorcycles and related parts and accessories" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.81", description: "Retail sale via stalls and markets of food, beverages and tobacco products" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Caravan Parks (Leisure) (National Scheme)": {
        SCAT: { code: "47", description: "Caravan Parks (Leisure) (National Scheme)" },
        CPA: { code: "55.30", description: "Camping grounds and recreational vehicle parks services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5530", description: "Camping grounds, recreational vehicle parks and trailer parks" },
        NACE_level_4: { code: "55.30", description: "Camping grounds and recreational vehicle parks" },
        NACE_level_3: { code: "55.3", description: "Camping grounds and recreational vehicle parks" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.30", description: "Camping grounds, recreational vehicle parks and trailer parks" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Caravan Sites and Pitches (National Scheme)": {
        SCAT: { code: "48", description: "Caravan Sites and Pitches (National Scheme)" },
        CPA: { code: "55.30", description: "Camping grounds and recreational vehicle parks services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5530", description: "Camping grounds, recreational vehicle parks and trailer parks" },
        NACE_level_4: { code: "55.30", description: "Camping grounds and recreational vehicle parks" },
        NACE_level_3: { code: "55.3", description: "Camping grounds and recreational vehicle parks" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.30", description: "Camping grounds, recreational vehicle parks and trailer parks" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Casinos and Gambling Clubs": {
        SCAT: { code: "49", description: "Casinos and Gambling Clubs" },
        CPA: { code: "92.00", description: "Gambling and betting services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9200", description: "Gambling and betting activities" },
        NACE_level_4: { code: "92.00", description: "Gambling and betting activities" },
        NACE_level_3: { code: "92.0", description: "Gambling and betting activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "92.00", description: "Gambling and betting activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Cattle Breeding Centres": {
        SCAT: { code: "50", description: "Cattle Breeding Centres" },
        CPA: { code: "01.41", description: "Dairy cattle, live; raw milk from dairy cattle" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0141", description: "Raising of cattle and buffaloes" },
        NACE_level_4: { code: "01.41", description: "Raising of dairy cattle" },
        NACE_level_3: { code: "01.4", description: "Animal production" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.41", description: "Raising of dairy cattle" },
        planning_classes: { code: "", description: "" },
    },
    "Cement Tile Works": {
        SCAT: { code: "51", description: "Cement Tile Works" },
        CPA: { code: "23.51", description: "Cement" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2394", description: "Manufacture of cement, lime and plaster" },
        NACE_level_4: { code: "23.51", description: "Manufacture of cement" },
        NACE_level_3: { code: "23.5", description: "Manufacture of cement, lime and plaster" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.51", description: "Manufacture of cement" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Cement Works": {
        SCAT: { code: "52", description: "Cement Works" },
        CPA: { code: "23.51", description: "Cement" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2394", description: "Manufacture of cement, lime and plaster" },
        NACE_level_4: { code: "23.51", description: "Manufacture of cement" },
        NACE_level_3: { code: "23.5", description: "Manufacture of cement, lime and plaster" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.51", description: "Manufacture of cement" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Cemeteries (National Scheme)": {
        SCAT: { code: "53", description: "Cemeteries (National Scheme)" },
        CPA: { code: "96.30", description: "Funeral and related services" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9630", description: "Funeral and related activities" },
        NACE_level_4: { code: "96.30", description: "Funeral and related activities" },
        NACE_level_3: { code: "96.3", description: "Funeral and related activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.03", description: "Funeral and related activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Chalet Parks (National Scheme)": {
        SCAT: { code: "54", description: "Chalet Parks (National Scheme)" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Chemical Works": {
        SCAT: { code: "55", description: "Chemical Works" },
        CPA: { code: "20.13", description: "Other inorganic basic chemicals" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2013", description: "Manufacture of plastics and synthetic rubber in primary forms" },
        NACE_level_4: { code: "20.13", description: "Manufacture of other inorganic basic chemicals" },
        NACE_level_3: { code: "20.1", description: "Manufacture of basic chemicals, fertilisers and nitrogen compounds, plastics and synthetic rubber in primary forms" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "20.13", description: "Manufacture of other inorganic basic chemicals" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Cinemas (National Scheme)": {
        SCAT: { code: "56", description: "Cinemas (National Scheme)" },
        CPA: { code: "59.14", description: "Motion picture projection services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "5914", description: "Motion picture projection activities" },
        NACE_level_4: { code: "59.14", description: "Motion picture projection activities" },
        NACE_level_3: { code: "59.1", description: "Motion picture, video and television programme activities" },
        NACE_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        UK_SIC: { code: "59.14", description: "Motion picture projection activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Civic and Public Buildings (Local Authority Occupations)": {
        SCAT: { code: "57", description: "Civic and Public Buildings (Local Authority Occupations)" },
        CPA: { code: "84.11", description: "General public administration services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8411", description: "General public administration activities" },
        NACE_level_4: { code: "84.11", description: "General public administration activities" },
        NACE_level_3: { code: "84.1", description: "Administration of the State and the economic, social and environmental policies of the community" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.11", description: "General public administration activities" },
        planning_classes: { code: "F2(b)", description: "Halls or meeting places for the principal use of the local community" },
    },
    "Civic Amenity Sites": {
        SCAT: { code: "58", description: "Civic Amenity Sites" },
        CPA: { code: "84.11", description: "General public administration services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8411", description: "General public administration activities" },
        NACE_level_4: { code: "84.11", description: "General public administration activities" },
        NACE_level_3: { code: "84.1", description: "Administration of the State and the economic, social and environmental policies of the community" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.11", description: "General public administration activities" },
        planning_classes: { code: "F2(b)", description: "Halls or meeting places for the principal use of the local community" },
    },
    "Civil Airports": {
        SCAT: { code: "59", description: "Civil Airports" },
        CPA: { code: "52.23", description: "Services incidental to air transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5223", description: "Service activities incidental to air transportation" },
        NACE_level_4: { code: "52.23", description: "Service activities incidental to air transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.23", description: "Service activities incidental to air transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Clubhouses": {
        SCAT: { code: "60", description: "Clubhouses" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Licensed Sports, Social & Private Members Clubs": {
        SCAT: { code: "61", description: "Licensed Sports, Social & Private Members Clubs" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Inns": {
        SCAT: { code: "62", description: "Inns" },
        CPA: { code: "55.10", description: "Hotel and similar accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5510", description: "Hotels and similar accommodation activities" },
        NACE_level_4: { code: "55.10", description: "Hotels and similar accommodation" },
        NACE_level_3: { code: "55.1", description: "Hotels and similar accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.10", description: "Hotels and similar accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Coking and Carbonising Plants": {
        SCAT: { code: "63", description: "Coking and Carbonising Plants" },
        CPA: { code: "19.10", description: "Coke oven products" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1910", description: "Manufacture of coke oven products" },
        NACE_level_4: { code: "19.10", description: "Manufacture of coke oven products" },
        NACE_level_3: { code: "19.1", description: "Manufacture of coke oven products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "19.10", description: "Manufacture of coke oven products" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Cold Stores": {
        SCAT: { code: "64", description: "Cold Stores" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Colleges of Further Education (National Scheme)": {
        SCAT: { code: "65", description: "Colleges of Further Education (National Scheme)" },
        CPA: { code: "85.32", description: "Vocational secondary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8532", description: "Vocational secondary education" },
        NACE_level_4: { code: "85.32", description: "Vocational secondary education" },
        NACE_level_3: { code: "85.3", description: "Secondary and post-secondary non-tertiary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.32", description: "Technical and vocational secondary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Communication Stations (National Scheme)": {
        SCAT: { code: "66", description: "Communication Stations (National Scheme)" },
        CPA: { code: "61.10", description: "Wired, wireless, and satellite telecommunication services" },
        ISIC_level_1: { code: "K", description: "Telecommunications, computer programming, consultancy, computing infrastructure, and other information service activities" },
        ISIC_level_4: { code: "6110", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_4: { code: "61.10", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_3: { code: "61.1", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.10", description: "Wired telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Community Day Centres": {
        SCAT: { code: "67", description: "Community Day Centres" },
        CPA: { code: "88.10", description: "Social work services without accommodation for older persons or persons with disabilities" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8810", description: "Social work activities without accommodation for older persons or persons with disabilities" },
        NACE_level_4: { code: "88.10", description: "Social work activities without accommodation for older persons or persons with disabilities" },
        NACE_level_3: { code: "88.1", description: "Social work activities without accommodation for older persons or persons with disabilities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "88.10", description: "Social work activities without accommodation for the elderly and disabled" },
        planning_classes: { code: "E(f)", description: "Creche, day nursery or day centre (not including a residential use)" },
    },
    "Computer Centres (Non-Purpose Built)": {
        SCAT: { code: "68", description: "Computer Centres (Non-Purpose Built)" },
        CPA: { code: "63.10", description: "Computing infrastructure, data processing, hosting and related services" },
        ISIC_level_1: { code: "K", description: "Telecommunications, computer programming, consultancy, computing infrastructure, and other information service activities" },
        ISIC_level_4: { code: "6310", description: "Computing infrastructure, data processing, hosting and related activities" },
        NACE_level_4: { code: "63.10", description: "Computing infrastructure, data processing, hosting and related activities" },
        NACE_level_3: { code: "63.1", description: "Computing infrastructure, data processing, hosting and related activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "63.11", description: "Data processing, hosting and related activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Computer Centres (Purpose Built)": {
        SCAT: { code: "69", description: "Computer Centres (Purpose Built)" },
        CPA: { code: "63.10", description: "Computing infrastructure, data processing, hosting and related services" },
        ISIC_level_1: { code: "K", description: "Telecommunications, computer programming, consultancy, computing infrastructure, and other information service activities" },
        ISIC_level_4: { code: "6310", description: "Computing infrastructure, data processing, hosting and related activities" },
        NACE_level_4: { code: "63.10", description: "Computing infrastructure, data processing, hosting and related activities" },
        NACE_level_3: { code: "63.1", description: "Computing infrastructure, data processing, hosting and related activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "63.11", description: "Data processing, hosting and related activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Concert Halls (National Scheme)": {
        SCAT: { code: "70", description: "Concert Halls (National Scheme)" },
        CPA: { code: "90.31", description: "Operation services of arts facilities and sites" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9031", description: "Operation of arts facilities and sites" },
        NACE_level_4: { code: "90.31", description: "Operation of arts facilities and sites" },
        NACE_level_3: { code: "90.3", description: "Support activities to arts creation and performing arts" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "90.04", description: "Operation of arts facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Concrete Batching Plants": {
        SCAT: { code: "71", description: "Concrete Batching Plants" },
        CPA: { code: "23.63", description: "Ready-mixed concrete" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2395", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_4: { code: "23.63", description: "Manufacture of ready-mixed concrete" },
        NACE_level_3: { code: "23.6", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.63", description: "Manufacture of ready-mixed concrete" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Concrete Block Works": {
        SCAT: { code: "72", description: "Concrete Block Works" },
        CPA: { code: "23.61", description: "Concrete products for construction purposes" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2395", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_4: { code: "23.61", description: "Manufacture of concrete products for construction purposes" },
        NACE_level_3: { code: "23.6", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.61", description: "Manufacture of concrete products for construction purposes" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Concrete Product Works": {
        SCAT: { code: "73", description: "Concrete Product Works" },
        CPA: { code: "23.61", description: "Concrete products for construction purposes" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2395", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_4: { code: "23.61", description: "Manufacture of concrete products for construction purposes" },
        NACE_level_3: { code: "23.6", description: "Manufacture of articles of concrete, cement and plaster" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.61", description: "Manufacture of concrete products for construction purposes" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Conference & Exhibition Centres": {
        SCAT: { code: "74", description: "Conference & Exhibition Centres" },
        CPA: { code: "82.30", description: "Organisation of conventions and trade shows services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8230", description: "Organization of conventions and trade shows" },
        NACE_level_4: { code: "82.30", description: "Organisation of conventions and trade shows" },
        NACE_level_3: { code: "82.3", description: "Organisation of conventions and trade shows" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.30", description: "Organisation of conventions and trade shows" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Wedding & Function Venues": {
        SCAT: { code: "75", description: "Wedding & Function Venues" },
        CPA: { code: "96.99", description: "Other personal services n.e.c." },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9690", description: "Other personal service activities n.e.c." },
        NACE_level_4: { code: "96.99", description: "Other personal service activities n.e.c." },
        NACE_level_3: { code: "96.9", description: "Other personal service activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Contractors Huts & Compounds": {
        SCAT: { code: "76", description: "Contractors Huts & Compounds" },
        CPA: { code: "43.12", description: "Site preparation works" },
        ISIC_level_1: { code: "F", description: "Construction" },
        ISIC_level_4: { code: "4312", description: "Site preparation" },
        NACE_level_4: { code: "43.12", description: "Site preparation" },
        NACE_level_3: { code: "43.1", description: "Demolition and site preparation" },
        NACE_level_1: { code: "F", description: "Construction" },
        UK_SIC: { code: "43.12", description: "Site preparation" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Country House Hotels": {
        SCAT: { code: "77", description: "Country House Hotels" },
        CPA: { code: "55.10", description: "Hotel and similar accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5510", description: "Hotels and similar accommodation activities" },
        NACE_level_4: { code: "55.10", description: "Hotels and similar accommodation" },
        NACE_level_3: { code: "55.1", description: "Hotels and similar accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.10", description: "Hotels and similar accommodation" },
        planning_classes: { code: "C1", description: "Hotels" },
    },
    "Creameries": {
        SCAT: { code: "79", description: "Creameries" },
        CPA: { code: "10.51", description: "Dairy and cheese products" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1050", description: "Manufacture of dairy products" },
        NACE_level_4: { code: "10.51", description: "Manufacture of dairy products" },
        NACE_level_3: { code: "10.5", description: "Manufacture of dairy products and edible ice" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.51", description: "Operation of dairies and cheese making" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Crematoria (With & Without Cemeteries) (National Scheme)": {
        SCAT: { code: "80", description: "Crematoria (With & Without Cemeteries) (National Scheme)" },
        CPA: { code: "96.30", description: "Funeral and related services" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9630", description: "Funeral and related activities" },
        NACE_level_4: { code: "96.30", description: "Funeral and related activities" },
        NACE_level_3: { code: "96.3", description: "Funeral and related activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.03", description: "Funeral and related activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Cricket Centres": {
        SCAT: { code: "81", description: "Cricket Centres" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Cricket Grounds (County)": {
        SCAT: { code: "82", description: "Cricket Grounds (County)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Cricket Grounds/Pitches (Non- County)": {
        SCAT: { code: "83", description: "Cricket Grounds/Pitches (Non- County)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Dance Schools & Centres": {
        SCAT: { code: "84", description: "Dance Schools & Centres" },
        CPA: { code: "85.52", description: "Cultural education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8552", description: "Cultural education" },
        NACE_level_4: { code: "85.52", description: "Cultural education" },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.52", description: "Cultural education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Day Nurseries/Play Schools": {
        SCAT: { code: "85", description: "Day Nurseries/Play Schools" },
        CPA: { code: "85.10", description: "Pre-primary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8510", description: "Pre-primary education" },
        NACE_level_4: { code: "85.10", description: "Pre-primary education" },
        NACE_level_3: { code: "85.1", description: "Pre-primary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.10", description: "Pre-primary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Departmental and Walk Round Stores (Large)": {
        SCAT: { code: "86", description: "Departmental and Walk Round Stores (Large)" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Distilleries": {
        SCAT: { code: "87", description: "Distilleries" },
        CPA: { code: "11.01", description: "Distilled, rectified and blended spirits" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1101", description: "Distilling, rectifying and blending of spirits" },
        NACE_level_4: { code: "11.01", description: "Distilling, rectifying and blending of spirits" },
        NACE_level_3: { code: "11.0", description: "Manufacture of beverages" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "11.01", description: "Distilling, rectifying and blending of spirits" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "District Heating Undertakings & Networks": {
        SCAT: { code: "88", description: "District Heating Undertakings & Networks" },
        CPA: { code: "35.30", description: "Steam and air conditioning supply services" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3530", description: "Steam and air conditioning supply" },
        NACE_level_4: { code: "35.30", description: "Steam and air conditioning supply" },
        NACE_level_3: { code: "35.3", description: "Steam and air conditioning supply" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.30", description: "Steam and air conditioning supply" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Docks and Harbours (Non-Statutory)": {
        SCAT: { code: "89", description: "Docks and Harbours (Non-Statutory)" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Domestic Fuel Installations": {
        SCAT: { code: "90", description: "Domestic Fuel Installations" },
        CPA: { code: "35.22", description: "Distribution services of gaseous fuels through mains" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3520", description: "Manufacture of gas; distribution of gaseous fuels through mains" },
        NACE_level_4: { code: "35.22", description: "Distribution of gaseous fuels through mains" },
        NACE_level_3: { code: "35.2", description: "Manufacture of gas, and distribution of gaseous fuels through mains" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.22", description: "Distribution of gaseous fuels through mains" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Drive-In Restaurants": {
        SCAT: { code: "91", description: "Drive-In Restaurants" },
        CPA: { code: "56.11", description: "Restaurant serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.11", description: "Restaurant activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Drive-Thru Restaurants": {
        SCAT: { code: "92", description: "Drive-Thru Restaurants" },
        CPA: { code: "56.11", description: "Restaurant serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.11", description: "Restaurant activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Mine Water Treatment Plant and Premises": {
        SCAT: { code: "93", description: "Mine Water Treatment Plant and Premises" },
        CPA: { code: "36.00", description: "Natural water; water treatment and supply services" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3600", description: "Water collection, treatment and supply" },
        NACE_level_4: { code: "36.00", description: "Water collection, treatment and supply" },
        NACE_level_3: { code: "36.0", description: "Water collection, treatment and supply" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "36.00", description: "Water collection, treatment and supply" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Electricity Undertakings (Non- Statutory)": {
        SCAT: { code: "94", description: "Electricity Undertakings (Non- Statutory)" },
        CPA: { code: "35.11", description: "Electricity from non-renewable sources" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3511", description: "Electric power generation activities from non-renewable sources" },
        NACE_level_4: { code: "35.11", description: "Production of electricity from non-renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.11", description: "Production of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Exhaust and Tyre Centres": {
        SCAT: { code: "95", description: "Exhaust and Tyre Centres" },
        CPA: { code: "95.31", description: "Repair and maintenance services of motor vehicles" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9531", description: "Repair and maintenance of motor vehicles" },
        NACE_level_4: { code: "95.31", description: "Repair and maintenance of motor vehicles" },
        NACE_level_3: { code: "95.3", description: "Repair and maintenance of motor vehicles and motorcycles" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "95.29", description: "Repair of other personal and household goods" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Factories, Workshops and Warehouses (Incl Bakeries & Dairies)": {
        SCAT: { code: "96", description: "Factories, Workshops and Warehouses (Incl Bakeries & Dairies)" },
        CPA: { code: "10.71", description: "Bread, fresh pastry goods and cakes" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1071", description: "Manufacture of bakery products" },
        NACE_level_4: { code: "10.71", description: "Manufacture of bread; manufacture of fresh pastry goods and cakes" },
        NACE_level_3: { code: "10.7", description: "Manufacture of bakery and farinaceous products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.71", description: "Manufacture of bread; manufacture of fresh pastry goods and cakes" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Factory Shops": {
        SCAT: { code: "97", description: "Factory Shops" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Farm Shops": {
        SCAT: { code: "98", description: "Farm Shops" },
        CPA: { code: "47.22", description: "Retail sale services of meat and meat products" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4722", description: "Retail sale of beverages" },
        NACE_level_4: { code: "47.22", description: "Retail sale of meat and meat products" },
        NACE_level_3: { code: "47.2", description: "Retail sale of food, beverages and tobacco" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.22", description: "Retail sale of meat and meat products in specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Field Study, Activity and Adventure Centres": {
        SCAT: { code: "99", description: "Field Study, Activity and Adventure Centres" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Film and TV Studios": {
        SCAT: { code: "100", description: "Film and TV Studios" },
        CPA: { code: "59.11", description: "Motion picture, video and television programme production services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "5911", description: "Motion picture, video and television programme production activities" },
        NACE_level_4: { code: "59.11", description: "Motion picture, video and television programme production activities" },
        NACE_level_3: { code: "59.1", description: "Motion picture, video and television programme activities" },
        NACE_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        UK_SIC: { code: "59.11", description: "Motion picture, video and television programme production activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Fire Stations": {
        SCAT: { code: "101", description: "Fire Stations" },
        CPA: { code: "84.25", description: "Fire brigade services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.25", description: "Fire service activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.25", description: "Fire service activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Fish Farms": {
        SCAT: { code: "102", description: "Fish Farms" },
        CPA: { code: "03.00", description: "Fish and other fishing products; aquaculture products; support services to fishing" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0322", description: "Freshwater aquaculture" },
        NACE_level_4: { code: "03.22", description: "Freshwater aquaculture" },
        NACE_level_3: { code: "03.2", description: "Aquaculture" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "03.22", description: "Freshwater aquaculture" },
        planning_classes: { code: "", description: "" },
    },
    "Flour Mills (National Scheme)": {
        SCAT: { code: "103", description: "Flour Mills (National Scheme)" },
        CPA: { code: "10.61", description: "Grain mill products" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1061", description: "Manufacture of grain mill products" },
        NACE_level_4: { code: "10.61", description: "Manufacture of grain mill products" },
        NACE_level_3: { code: "10.6", description: "Manufacture of grain mill products, starches and starch products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.61", description: "Manufacture of grain mill products" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Food Courts": {
        SCAT: { code: "104", description: "Food Courts" },
        CPA: { code: "56.11", description: "Restaurant serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.11", description: "Restaurant activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Food Processing Centres": {
        SCAT: { code: "105", description: "Food Processing Centres" },
        CPA: { code: "10.89", description: "Other food products n.e.c." },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1079", description: "Manufacture of other food products n.e.c." },
        NACE_level_4: { code: "10.89", description: "Manufacture of other food products n.e.c." },
        NACE_level_3: { code: "10.8", description: "Manufacture of other food products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.89", description: "Manufacture of other food products n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Convenience Store": {
        SCAT: { code: "106", description: "Convenience Store" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4711", description: "Non-specialized retail sale with food, beverages or tobacco predominating" },
        NACE_level_4: { code: "47.11", description: "Non-specialised retail sale of predominately food, beverages or tobacco" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.11", description: "Retail sale in non-specialised stores with food, beverages or tobacco predominating" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Football Grounds": {
        SCAT: { code: "107", description: "Football Grounds" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Football Pitches": {
        SCAT: { code: "108", description: "Football Pitches" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Football Stadia": {
        SCAT: { code: "109", description: "Football Stadia" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Foundries": {
        SCAT: { code: "110", description: "Foundries" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_3: { code: "", description: "missing entry in classification" },
        NACE_level_1: { code: "", description: "missing entry in classification" },
        UK_SIC: { code: "", description: "missing entry in classification" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Funeral Parlours/Chapels Of Rest": {
        SCAT: { code: "111", description: "Funeral Parlours/Chapels Of Rest" },
        CPA: { code: "96.30", description: "Funeral and related services" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9630", description: "Funeral and related activities" },
        NACE_level_4: { code: "96.30", description: "Funeral and related activities" },
        NACE_level_3: { code: "96.3", description: "Funeral and related activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.03", description: "Funeral and related activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Game Farms": {
        SCAT: { code: "112", description: "Game Farms" },
        CPA: { code: "01.48", description: "Other animals and animal products" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0149", description: "Raising of other animals" },
        NACE_level_4: { code: "01.48", description: "Raising of other animals" },
        NACE_level_3: { code: "01.4", description: "Animal production" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.49", description: "Raising of other animals" },
        planning_classes: { code: "", description: "" },
    },
    "Garages (Transport and Commercial)": {
        SCAT: { code: "113", description: "Garages (Transport and Commercial)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Garden Centres": {
        SCAT: { code: "114", description: "Garden Centres" },
        CPA: { code: "47.76", description: "Retail sale services of flowers, plants, fertilisers, pets and pet food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4773", description: "Retail sale of other new goods n.e.c." },
        NACE_level_4: { code: "47.76", description: "Retail sale of flowers, plants, fertilisers, pets and pet food" },
        NACE_level_3: { code: "47.7", description: "Retail sale of other goods, except motor vehicles and motorcycles" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.76", description: "Retail sale of flowers, plants, seeds, fertilisers, pet animals and pet food in specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Gas Processing Plants": {
        SCAT: { code: "115", description: "Gas Processing Plants" },
        CPA: { code: "35.21", description: "Manufactured gas, for energy supply" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3520", description: "Manufacture of gas; distribution of gaseous fuels through mains" },
        NACE_level_4: { code: "35.21", description: "Manufacture of gas" },
        NACE_level_3: { code: "35.2", description: "Manufacture of gas, and distribution of gaseous fuels through mains" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.21", description: "Manufacture of gas" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Go Kart Rinks": {
        SCAT: { code: "116", description: "Go Kart Rinks" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Golf Courses": {
        SCAT: { code: "117", description: "Golf Courses" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Golf Driving Ranges": {
        SCAT: { code: "118", description: "Golf Driving Ranges" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Grain Silos": {
        SCAT: { code: "119", description: "Grain Silos" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Granaries and Intervention Stores": {
        SCAT: { code: "120", description: "Granaries and Intervention Stores" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Greyhound Racetracks": {
        SCAT: { code: "121", description: "Greyhound Racetracks" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Guest & Boarding Houses": {
        SCAT: { code: "122", description: "Guest & Boarding Houses" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "C1", description: "Hotels" },
    },
    "Traveller Sites": {
        SCAT: { code: "123", description: "Traveller Sites" },
        CPA: { code: "55.30", description: "Camping grounds and recreational vehicle parks services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5530", description: "Camping grounds, recreational vehicle parks and trailer parks" },
        NACE_level_4: { code: "55.30", description: "Camping grounds and recreational vehicle parks" },
        NACE_level_3: { code: "55.3", description: "Camping grounds and recreational vehicle parks" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.30", description: "Camping grounds, recreational vehicle parks and trailer parks" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Hatcheries/Poultry Farms": {
        SCAT: { code: "124", description: "Hatcheries/Poultry Farms" },
        CPA: { code: "01.47", description: "Poultry, live and eggs" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0146", description: "Raising of poultry" },
        NACE_level_4: { code: "01.47", description: "Raising of poultry" },
        NACE_level_3: { code: "01.4", description: "Animal production" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.47", description: "Raising of poultry" },
        planning_classes: { code: "", description: "" },
    },
    "Health Farms": {
        SCAT: { code: "125", description: "Health Farms" },
        CPA: { code: "86.99", description: "Other human health services n.e.c." },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8699", description: "Other human health activities n.e.c." },
        NACE_level_4: { code: "86.99", description: "Other human health activities n.e.c." },
        NACE_level_3: { code: "86.9", description: "Other human health activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.90", description: "Other human health activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Heliports": {
        SCAT: { code: "126", description: "Heliports" },
        CPA: { code: "52.23", description: "Services incidental to air transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5223", description: "Service activities incidental to air transportation" },
        NACE_level_4: { code: "52.23", description: "Service activities incidental to air transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.23", description: "Service activities incidental to air transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Heredits Used For Primary Treatment/Processing Of Minerals": {
        SCAT: { code: "127", description: "Heredits Used For Primary Treatment/Processing Of Minerals" },
        CPA: { code: "08.11", description: "Ornamental stone, limestone, gypsum, slate and other stone" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.11", description: "Quarrying of ornamental stone, limestone, gypsum, slate and other stone" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.11", description: "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Heritage Railways": {
        SCAT: { code: "128", description: "Heritage Railways" },
        CPA: { code: "49.11", description: "Passenger heavy rail transport services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "4911", description: "Passenger rail transport, interurban" },
        NACE_level_4: { code: "49.11", description: "Passenger heavy rail transport" },
        NACE_level_3: { code: "49.1", description: "Passenger rail transport" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "49.10", description: "Passenger rail transport, interurban" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "High Tech Warehouses": {
        SCAT: { code: "129", description: "High Tech Warehouses" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Holiday Centres": {
        SCAT: { code: "130", description: "Holiday Centres" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Holiday Homes (Self Catering)": {
        SCAT: { code: "131", description: "Holiday Homes (Self Catering)" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Horse Racecourses": {
        SCAT: { code: "132", description: "Horse Racecourses" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Hospital Let Outs": {
        SCAT: { code: "133", description: "Hospital Let Outs" },
        CPA: { code: "68.20", description: "Rental and operating services of own or leased real estate" },
        ISIC_level_1: { code: "M", description: "Real estate activities" },
        ISIC_level_4: { code: "6821", description: "Intermediation service activities for real estate" },
        NACE_level_4: { code: "68.20", description: "Rental and operating of own or leased real estate" },
        NACE_level_3: { code: "68.2", description: "Rental and operating of own or leased real estate" },
        NACE_level_1: { code: "M", description: "Real estate activities" },
        UK_SIC: { code: "68.20", description: "Renting and operating of own or leased real estate" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Hospitals & Clinics NHS (National Scheme)": {
        SCAT: { code: "134", description: "Hospitals & Clinics NHS (National Scheme)" },
        CPA: { code: "86.10", description: "Hospital services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8610", description: "Hospital activities" },
        NACE_level_4: { code: "86.10", description: "Hospital activities" },
        NACE_level_3: { code: "86.1", description: "Hospital activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.10", description: "Hospital activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Hospitals & Clinics (Private) (National Scheme)": {
        SCAT: { code: "135", description: "Hospitals & Clinics (Private) (National Scheme)" },
        CPA: { code: "86.10", description: "Hospital services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8610", description: "Hospital activities" },
        NACE_level_4: { code: "86.10", description: "Hospital activities" },
        NACE_level_3: { code: "86.1", description: "Hospital activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.10", description: "Hospital activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Hostels": {
        SCAT: { code: "136", description: "Hostels" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Hotels (3 Star And Under)": {
        SCAT: { code: "137", description: "Hotels (3 Star And Under)" },
        CPA: { code: "55.10", description: "Hotel and similar accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5510", description: "Hotels and similar accommodation activities" },
        NACE_level_4: { code: "55.10", description: "Hotels and similar accommodation" },
        NACE_level_3: { code: "55.1", description: "Hotels and similar accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.10", description: "Hotels and similar accommodation" },
        planning_classes: { code: "C1", description: "Hotels" },
    },
    "Hotels (4 Star & Above) & Major Chain Operated ( includes 3* & above consortium hotels)": {
        SCAT: { code: "138", description: "Hotels (4 Star & Above) & Major Chain Operated ( includes 3* & above consortium hotels)" },
        CPA: { code: "55.10", description: "Hotel and similar accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5510", description: "Hotels and similar accommodation activities" },
        NACE_level_4: { code: "55.10", description: "Hotels and similar accommodation" },
        NACE_level_3: { code: "55.1", description: "Hotels and similar accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.10", description: "Hotels and similar accommodation" },
        planning_classes: { code: "C1", description: "Hotels" },
    },
    "Hypermarkets/Superstores (over 2500m²)": {
        SCAT: { code: "139", description: "Hypermarkets/Superstores (over 2500m²)" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4711", description: "Non-specialized retail sale with food, beverages or tobacco predominating" },
        NACE_level_4: { code: "47.11", description: "Non-specialised retail sale of predominately food, beverages or tobacco" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.11", description: "Retail sale in non-specialised stores with food, beverages or tobacco predominating" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Ice Rinks": {
        SCAT: { code: "140", description: "Ice Rinks" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(d)", description: "Indoor or outdoor swimming pools or skating rinks" },
    },
    "Interactive Telephone Kiosks": {
        SCAT: { code: "141", description: "Interactive Telephone Kiosks" },
        CPA: { code: "61.90", description: "Other telecommunication services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "6190", description: "Other telecommunication activities" },
        NACE_level_4: { code: "61.90", description: "Other telecommunication activities" },
        NACE_level_3: { code: "61.9", description: "Other telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.90", description: "Other telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Iron and/or Steel Works": {
        SCAT: { code: "142", description: "Iron and/or Steel Works" },
        CPA: { code: "24.10", description: "Basic iron, steel and ferro-alloys" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2410", description: "Manufacture of basic iron and steel" },
        NACE_level_4: { code: "24.10", description: "Manufacture of basic iron and steel and of ferro-alloys" },
        NACE_level_3: { code: "24.1", description: "Manufacture of basic iron and steel and of ferro-alloys" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "24.10", description: "Manufacture of basic iron and steel and of ferro-alloys" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Kennels and Catteries": {
        SCAT: { code: "143", description: "Kennels and Catteries" },
        CPA: { code: "75.00", description: "Veterinary services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7500", description: "Veterinary activities" },
        NACE_level_4: { code: "75.00", description: "Veterinary activities" },
        NACE_level_3: { code: "75.0", description: "Veterinary activities" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "75.00", description: "Veterinary activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Laboratories": {
        SCAT: { code: "144", description: "Laboratories" },
        CPA: { code: "72.10", description: "Research and development services on natural sciences, engineering and technology" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7210", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_4: { code: "72.10", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_3: { code: "72.1", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "72.19", description: "Other research and experimental development on natural sciences and engineering" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "Lakes With Water Sport Facilities": {
        SCAT: { code: "145", description: "Lakes With Water Sport Facilities" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Land Used For Advertising": {
        SCAT: { code: "146", description: "Land Used For Advertising" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Land Used For Car Boot Sales": {
        SCAT: { code: "147", description: "Land Used For Car Boot Sales" },
        CPA: { code: "47.81", description: "Retail sale services of motor vehicles" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4781", description: "Retail sale of motor vehicles" },
        NACE_level_4: { code: "47.81", description: "Retail sale of motor vehicles" },
        NACE_level_3: { code: "47.8", description: "Retail sale of motor vehicles, motorcycles and related parts and accessories" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.81", description: "Retail sale via stalls and markets of food, beverages and tobacco products" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Land Used For Storage": {
        SCAT: { code: "148", description: "Land Used For Storage" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Landfill Gas Generator Sites": {
        SCAT: { code: "149", description: "Landfill Gas Generator Sites" },
        CPA: { code: "35.21", description: "Manufactured gas, for energy supply" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3520", description: "Manufacture of gas; distribution of gaseous fuels through mains" },
        NACE_level_4: { code: "35.21", description: "Manufacture of gas" },
        NACE_level_3: { code: "35.2", description: "Manufacture of gas, and distribution of gaseous fuels through mains" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.21", description: "Manufacture of gas" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Land used for Waste Composting": {
        SCAT: { code: "150", description: "Land used for Waste Composting" },
        CPA: { code: "38.23", description: "Other waste recovery services" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3830", description: "Materials and other waste recovery" },
        NACE_level_4: { code: "38.23", description: "Other waste recovery" },
        NACE_level_3: { code: "38.2", description: "Waste recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "38.32", description: "Recovery of sorted materials" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Large Distribution Warehouses": {
        SCAT: { code: "151", description: "Large Distribution Warehouses" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Large Food Stores (750 - 2500m²)": {
        SCAT: { code: "152", description: "Large Food Stores (750 - 2500m²)" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4711", description: "Non-specialized retail sale with food, beverages or tobacco predominating" },
        NACE_level_4: { code: "47.11", description: "Non-specialised retail sale of predominately food, beverages or tobacco" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.11", description: "Retail sale in non-specialised stores with food, beverages or tobacco predominating" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Large Industrials (Over 20,000m²)": {
        SCAT: { code: "153", description: "Large Industrials (Over 20,000m²)" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "T", description: "Other service activities" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_3: { code: "", description: "missing entry in classification" },
        NACE_level_1: { code: "", description: "missing entry in classification" },
        UK_SIC: { code: "", description: "missing entry in classification" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Large Shops (750 - 1850m²)": {
        SCAT: { code: "154", description: "Large Shops (750 - 1850m²)" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Large Shops (Over 1850m²)": {
        SCAT: { code: "155", description: "Large Shops (Over 1850m²)" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Libraries": {
        SCAT: { code: "156", description: "Libraries" },
        CPA: { code: "91.11", description: "Library services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "9111", description: "Library activities" },
        NACE_level_4: { code: "91.11", description: "Library activities" },
        NACE_level_3: { code: "91.1", description: "Library and archive activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.01", description: "Library and archive activities" },
        planning_classes: { code: "F1(d)", description: "Public libraries or public reading rooms" },
    },
    "Liquid Bulk Storage (Incl Petrol & Oil) (National Scheme)": {
        SCAT: { code: "157", description: "Liquid Bulk Storage (Incl Petrol & Oil) (National Scheme)" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Livestock Markets (National Scheme)": {
        SCAT: { code: "158", description: "Livestock Markets (National Scheme)" },
        CPA: { code: "47.22", description: "Retail sale services of meat and meat products" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4722", description: "Retail sale of beverages" },
        NACE_level_4: { code: "47.22", description: "Retail sale of meat and meat products" },
        NACE_level_3: { code: "47.2", description: "Retail sale of food, beverages and tobacco" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.22", description: "Retail sale of meat and meat products in specialised stores" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Local Authority Schools (National Scheme)": {
        SCAT: { code: "159", description: "Local Authority Schools (National Scheme)" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Lodges (National Scheme)": {
        SCAT: { code: "160", description: "Lodges (National Scheme)" },
        CPA: { code: "55.10", description: "Hotel and similar accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5510", description: "Hotels and similar accommodation activities" },
        NACE_level_4: { code: "55.10", description: "Hotels and similar accommodation" },
        NACE_level_3: { code: "55.1", description: "Hotels and similar accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.10", description: "Hotels and similar accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Lorry Parks": {
        SCAT: { code: "161", description: "Lorry Parks" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Maltings - Non Trad": {
        SCAT: { code: "162", description: "Maltings - Non Trad" },
        CPA: { code: "11.06", description: "Malt" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1104", description: "Manufacture of malt" },
        NACE_level_4: { code: "11.06", description: "Manufacture of malt" },
        NACE_level_3: { code: "11.0", description: "Manufacture of beverages" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "11.06", description: "Manufacture of malt" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Maltings - Trad": {
        SCAT: { code: "163", description: "Maltings - Trad" },
        CPA: { code: "11.06", description: "Malt" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1104", description: "Manufacture of malt" },
        NACE_level_4: { code: "11.06", description: "Manufacture of malt" },
        NACE_level_3: { code: "11.0", description: "Manufacture of beverages" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "11.06", description: "Manufacture of malt" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Marinas (National Scheme)": {
        SCAT: { code: "164", description: "Marinas (National Scheme)" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Markets (Other Than Livestock)": {
        SCAT: { code: "165", description: "Markets (Other Than Livestock)" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Mineral Depot and Premises": {
        SCAT: { code: "166", description: "Mineral Depot and Premises" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Blockstone": {
        SCAT: { code: "167", description: "Mineral Producing Hereditament - Blockstone" },
        CPA: { code: "08.11", description: "Ornamental stone, limestone, gypsum, slate and other stone" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.11", description: "Quarrying of ornamental stone, limestone, gypsum, slate and other stone" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.11", description: "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Brine": {
        SCAT: { code: "168", description: "Mineral Producing Hereditament - Brine" },
        CPA: { code: "08.93", description: "Salt and pure sodium chloride; sea water" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0893", description: "Extraction of salt" },
        NACE_level_4: { code: "08.93", description: "Extraction of salt" },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.93", description: "Extraction of salt" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Chalk": {
        SCAT: { code: "169", description: "Mineral Producing Hereditament - Chalk" },
        CPA: { code: "08.11", description: "Ornamental stone, limestone, gypsum, slate and other stone" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.11", description: "Quarrying of ornamental stone, limestone, gypsum, slate and other stone" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.11", description: "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - China Clay": {
        SCAT: { code: "170", description: "Mineral Producing Hereditament - China Clay" },
        CPA: { code: "08.12", description: "Gravel, sand, clay and kaolin" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.12", description: "Operation of gravel and sand pits and mining of clay and kaolin" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.12", description: "Operation of gravel and sand pits; mining of clays and kaolin" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Clay": {
        SCAT: { code: "171", description: "Mineral Producing Hereditament - Clay" },
        CPA: { code: "08.12", description: "Gravel, sand, clay and kaolin" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.12", description: "Operation of gravel and sand pits and mining of clay and kaolin" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.12", description: "Operation of gravel and sand pits; mining of clays and kaolin" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Coal": {
        SCAT: { code: "172", description: "Mineral Producing Hereditament - Coal" },
        CPA: { code: "05.10", description: "Hard coal and other coal" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0510", description: "Mining of hard coal" },
        NACE_level_4: { code: "05.10", description: "Mining of hard coal" },
        NACE_level_3: { code: "05.1", description: "Mining of hard coal" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "05.10", description: "Mining of hard coal" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Fluorspar": {
        SCAT: { code: "173", description: "Mineral Producing Hereditament - Fluorspar" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Gas": {
        SCAT: { code: "174", description: "Mineral Producing Hereditament - Gas" },
        CPA: { code: "06.20", description: "Natural gas, liquefied or in gaseous state" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0620", description: "Extraction of natural gas" },
        NACE_level_4: { code: "06.20", description: "Extraction of natural gas" },
        NACE_level_3: { code: "06.2", description: "Extraction of natural gas" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "06.20", description: "Extraction of natural gas" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Hardrock": {
        SCAT: { code: "175", description: "Mineral Producing Hereditament - Hardrock" },
        CPA: { code: "08.11", description: "Ornamental stone, limestone, gypsum, slate and other stone" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.11", description: "Quarrying of ornamental stone, limestone, gypsum, slate and other stone" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.11", description: "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Inert": {
        SCAT: { code: "176", description: "Mineral Producing Hereditament - Inert" },
        CPA: { code: "08.12", description: "Gravel, sand, clay and kaolin" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.12", description: "Operation of gravel and sand pits and mining of clay and kaolin" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.12", description: "Operation of gravel and sand pits; mining of clays and kaolin" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Oil": {
        SCAT: { code: "177", description: "Mineral Producing Hereditament - Oil" },
        CPA: { code: "06.10", description: "Crude petroleum" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0610", description: "Extraction of crude petroleum" },
        NACE_level_4: { code: "06.10", description: "Extraction of crude petroleum" },
        NACE_level_3: { code: "06.1", description: "Extraction of crude petroleum" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "06.10", description: "Extraction of crude petroleum" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Other Mineral Category": {
        SCAT: { code: "178", description: "Mineral Producing Hereditament - Other Mineral Category" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Putrescible": {
        SCAT: { code: "179", description: "Mineral Producing Hereditament - Putrescible" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Sand and Gravel": {
        SCAT: { code: "180", description: "Mineral Producing Hereditament - Sand and Gravel" },
        CPA: { code: "08.12", description: "Gravel, sand, clay and kaolin" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.12", description: "Operation of gravel and sand pits and mining of clay and kaolin" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.12", description: "Operation of gravel and sand pits; mining of clays and kaolin" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Sand": {
        SCAT: { code: "181", description: "Mineral Producing Hereditament - Sand" },
        CPA: { code: "08.12", description: "Gravel, sand, clay and kaolin" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.12", description: "Operation of gravel and sand pits and mining of clay and kaolin" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.12", description: "Operation of gravel and sand pits; mining of clays and kaolin" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Shale Unburnt": {
        SCAT: { code: "182", description: "Mineral Producing Hereditament - Shale Unburnt" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament - Slate": {
        SCAT: { code: "183", description: "Mineral Producing Hereditament - Slate" },
        CPA: { code: "08.11", description: "Ornamental stone, limestone, gypsum, slate and other stone" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0810", description: "Quarrying of stone, sand and clay" },
        NACE_level_4: { code: "08.11", description: "Quarrying of ornamental stone, limestone, gypsum, slate and other stone" },
        NACE_level_3: { code: "08.1", description: "Quarrying of stone, sand and clay" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.11", description: "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament With Batching Plant": {
        SCAT: { code: "184", description: "Mineral Producing Hereditament With Batching Plant" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Hereditament With Coating Plant": {
        SCAT: { code: "185", description: "Mineral Producing Hereditament With Coating Plant" },
        CPA: { code: "20.30", description: "Paints, varnishes and similar coatings, printing ink and mastics" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2030", description: "Manufacture of man-made fibres" },
        NACE_level_4: { code: "20.30", description: "Manufacture of paints, varnishes and similar coatings, printing ink and mastics" },
        NACE_level_3: { code: "20.3", description: "Manufacture of paints, varnishes and similar coatings, printing ink and mastics" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "20.30", description: "Manufacture of paints, varnishes and similar coatings, printing ink and mastics" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Mineral Producing Heredtament With Tunnel Kiln": {
        SCAT: { code: "186", description: "Mineral Producing Heredtament With Tunnel Kiln" },
        CPA: { code: "23.32", description: "Bricks, tiles and construction products, in baked clay" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2392", description: "Manufacture of clay building materials" },
        NACE_level_4: { code: "23.32", description: "Manufacture of bricks, tiles and construction products, in baked clay" },
        NACE_level_3: { code: "23.3", description: "Manufacture of clay building materials" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.32", description: "Manufacture of bricks, tiles and construction products, in baked clay" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "MOD Hereditaments": {
        SCAT: { code: "187", description: "MOD Hereditaments" },
        CPA: { code: "84.22", description: "Defence services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8422", description: "Defence activities" },
        NACE_level_4: { code: "84.22", description: "Defence activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.22", description: "Defence activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Model Villages": {
        SCAT: { code: "188", description: "Model Villages" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Moorings (Floating Hereditaments)": {
        SCAT: { code: "189", description: "Moorings (Floating Hereditaments)" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Mortuaries": {
        SCAT: { code: "190", description: "Mortuaries" },
        CPA: { code: "96.30", description: "Funeral and related services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "9630", description: "Funeral and related activities" },
        NACE_level_4: { code: "96.30", description: "Funeral and related activities" },
        NACE_level_3: { code: "96.3", description: "Funeral and related activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.03", description: "Funeral and related activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Motor Racetracks": {
        SCAT: { code: "191", description: "Motor Racetracks" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Motor Vehicle Works": {
        SCAT: { code: "192", description: "Motor Vehicle Works" },
        CPA: { code: "29.10", description: "Motor vehicles" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2910", description: "Manufacture of motor vehicles" },
        NACE_level_4: { code: "29.10", description: "Manufacture of motor vehicles" },
        NACE_level_3: { code: "29.1", description: "Manufacture of motor vehicles" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "29.10", description: "Manufacture of motor vehicles" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Motorway Service Area Let Outs": {
        SCAT: { code: "193", description: "Motorway Service Area Let Outs" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Motorway and Major Road Service Areas": {
        SCAT: { code: "194", description: "Motorway and Major Road Service Areas" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Museums and Art Galleries (Contractors)": {
        SCAT: { code: "195", description: "Museums and Art Galleries (Contractors)" },
        CPA: { code: "91.21", description: "Museum and collection services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9121", description: "Museum and collection activities" },
        NACE_level_4: { code: "91.21", description: "Museum and collection activities" },
        NACE_level_3: { code: "91.2", description: "Museum, collection, historical site and monument activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.02", description: "Museum activities" },
        planning_classes: { code: "F1(c)", description: "Museums" },
    },
    "Museums and Art Galleries (NonContractors)": {
        SCAT: { code: "196", description: "Museums and Art Galleries (NonContractors)" },
        CPA: { code: "91.21", description: "Museum and collection services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9121", description: "Museum and collection activities" },
        NACE_level_4: { code: "91.21", description: "Museum and collection activities" },
        NACE_level_3: { code: "91.2", description: "Museum, collection, historical site and monument activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.02", description: "Museum activities" },
        planning_classes: { code: "F1(c)", description: "Museums" },
    },
    "Navy Hereditaments": {
        SCAT: { code: "197", description: "Navy Hereditaments" },
        CPA: { code: "84.22", description: "Defence services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8422", description: "Defence activities" },
        NACE_level_4: { code: "84.22", description: "Defence activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.22", description: "Defence activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Newspaper Printing Works (National Scheme)": {
        SCAT: { code: "198", description: "Newspaper Printing Works (National Scheme)" },
        CPA: { code: "18.12", description: "Other printing services" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1812", description: "Service activities related to printing" },
        NACE_level_4: { code: "18.12", description: "Other printing" },
        NACE_level_3: { code: "18.1", description: "Printing and service activities related to printing" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "18.12", description: "Other printing" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Night Clubs & Discotheques": {
        SCAT: { code: "199", description: "Night Clubs & Discotheques" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Nuclear Establishments": {
        SCAT: { code: "200", description: "Nuclear Establishments" },
        CPA: { code: "24.46", description: "Natural uranium and its compounds; alloys, dispersions, ceramic products and mixtures containing natural uranium or natural uranium compounds" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "24.46", description: "Processing of nuclear fuel" },
        NACE_level_3: { code: "24.4", description: "Manufacture of basic precious and other non-ferrous metals" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "24.46", description: "Processing of nuclear fuel" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Nursing Homes (Inc. Old Peoples Homes)": {
        SCAT: { code: "201", description: "Nursing Homes (Inc. Old Peoples Homes)" },
        CPA: { code: "87.10", description: "Residential nursing care services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8710", description: "Residential nursing care activities" },
        NACE_level_4: { code: "87.10", description: "Residential nursing care activities" },
        NACE_level_3: { code: "87.1", description: "Residential nursing care activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "87.10", description: "Residential nursing care activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Observatories": {
        SCAT: { code: "202", description: "Observatories" },
        CPA: { code: "72.10", description: "Research and development services on natural sciences, engineering and technology" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7210", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_4: { code: "72.10", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_3: { code: "72.1", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "72.19", description: "Other research and experimental development on natural sciences and engineering" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "Offices (Inc Computer Centres)": {
        SCAT: { code: "203", description: "Offices (Inc Computer Centres)" },
        CPA: { code: "70.20", description: "Business and other management consultancy services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7020", description: "Business and other management consultancy activities" },
        NACE_level_4: { code: "70.20", description: "Business and other management consultancy activities" },
        NACE_level_3: { code: "70.2", description: "Business and other management consultancy activities" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "70.22", description: "Business and other management consultancy activities" },
        planning_classes: { code: "E(g)(i)", description: "Offices to carry out any operational or administrative functions" },
    },
    "Offices (Headquarters/Institutional)": {
        SCAT: { code: "204", description: "Offices (Headquarters/Institutional)" },
        CPA: { code: "70.10", description: "Services of head offices" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7010", description: "Activities of head offices" },
        NACE_level_4: { code: "70.10", description: "Activities of head offices" },
        NACE_level_3: { code: "70.1", description: "Activities of head offices" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "70.10", description: "Activities of head offices" },
        planning_classes: { code: "E(g)(i)", description: "Offices to carry out any operational or administrative functions" },
    },
    "Oil Refineries": {
        SCAT: { code: "205", description: "Oil Refineries" },
        CPA: { code: "19.20", description: "Refined petroleum products and fossil fuel products" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1920", description: "Manufacture of refined petroleum products; manufacture of fossil fuel products" },
        NACE_level_4: { code: "19.20", description: "Manufacture of refined petroleum products and fossil fuel products" },
        NACE_level_3: { code: "19.2", description: "Manufacture of refined petroleum products and fossil fuel products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "19.20", description: "Manufacture of refined petroleum products" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Oxbridge Colleges": {
        SCAT: { code: "206", description: "Oxbridge Colleges" },
        CPA: { code: "85.40", description: "Tertiary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8540", description: "Tertiary education" },
        NACE_level_4: { code: "85.40", description: "Tertiary education" },
        NACE_level_3: { code: "85.4", description: "Tertiary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.42", description: "Tertiary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Paper Mills": {
        SCAT: { code: "207", description: "Paper Mills" },
        CPA: { code: "17.12", description: "Paper and paperboard" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1701", description: "Manufacture of pulp, paper and paperboard" },
        NACE_level_4: { code: "17.12", description: "Manufacture of paper and paperboard" },
        NACE_level_3: { code: "17.1", description: "Manufacture of pulp, paper and paperboard" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "17.12", description: "Manufacture of paper and paperboard" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Pavilions": {
        SCAT: { code: "208", description: "Pavilions" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Petrol Filling Stations (National Scheme)": {
        SCAT: { code: "209", description: "Petrol Filling Stations (National Scheme)" },
        CPA: { code: "47.30", description: "Retail sale services of automotive fuel" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4730", description: "Retail sale of automotive fuel" },
        NACE_level_4: { code: "47.30", description: "Retail sale of automotive fuel" },
        NACE_level_3: { code: "47.3", description: "Retail sale of automotive fuel" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.30", description: "Retail sale of automotive fuel in specialised stores" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Pharmacies": {
        SCAT: { code: "210", description: "Pharmacies" },
        CPA: { code: "47.73", description: "Retail sale services of pharmaceutical products" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4773", description: "Retail sale of other new goods n.e.c." },
        NACE_level_4: { code: "47.73", description: "Retail sale of pharmaceutical products" },
        NACE_level_3: { code: "47.7", description: "Retail sale of other goods, except motor vehicles and motorcycles" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.73", description: "Dispensing chemist in specialised stores" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Photographic Booths": {
        SCAT: { code: "211", description: "Photographic Booths" },
        CPA: { code: "74.20", description: "Photographic services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7420", description: "Photographic activities" },
        NACE_level_4: { code: "74.20", description: "Photographic activities" },
        NACE_level_3: { code: "74.2", description: "Photographic activities" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "74.20", description: "Photographic activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Pipelines": {
        SCAT: { code: "212", description: "Pipelines" },
        CPA: { code: "49.50", description: "Transport services via pipeline" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "4930", description: "Transport via pipeline" },
        NACE_level_4: { code: "49.50", description: "Transport via pipeline" },
        NACE_level_3: { code: "49.5", description: "Transport via pipeline" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "49.50", description: "Transport via pipeline" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Pleasure Piers": {
        SCAT: { code: "213", description: "Pleasure Piers" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Point to Point and Eventing Courses": {
        SCAT: { code: "214", description: "Point to Point and Eventing Courses" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Police Stations": {
        SCAT: { code: "215", description: "Police Stations" },
        CPA: { code: "84.24", description: "Public order and safety services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.24", description: "Public order and safety activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.24", description: "Public order and safety activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Polo Grounds": {
        SCAT: { code: "216", description: "Polo Grounds" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Post Office Sorting Centres": {
        SCAT: { code: "217", description: "Post Office Sorting Centres" },
        CPA: { code: "53.20", description: "Other postal and courier services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5320", description: "Courier activities" },
        NACE_level_4: { code: "53.20", description: "Other postal and courier activities" },
        NACE_level_3: { code: "53.2", description: "Other postal and courier activities" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "53.20", description: "Other postal and courier activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Potteries": {
        SCAT: { code: "218", description: "Potteries" },
        CPA: { code: "23.45", description: "Other ceramic products" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2393", description: "Manufacture of other porcelain and ceramic products" },
        NACE_level_4: { code: "23.45", description: "Manufacture of other ceramic products" },
        NACE_level_3: { code: "23.4", description: "Manufacture of other porcelain and ceramic products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "23.49", description: "Manufacture of other ceramic products" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Power Generators": {
        SCAT: { code: "219", description: "Power Generators" },
        CPA: { code: "35.11", description: "Electricity from non-renewable sources" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3511", description: "Electric power generation activities from non-renewable sources" },
        NACE_level_4: { code: "35.11", description: "Production of electricity from non-renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.11", description: "Production of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Prison Service Hereditaments": {
        SCAT: { code: "220", description: "Prison Service Hereditaments" },
        CPA: { code: "84.23", description: "Justice and judicial services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.23", description: "Justice and judicial activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.23", description: "Justice and judicial activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Property used for Secondary Aggregate Processing": {
        SCAT: { code: "221", description: "Property used for Secondary Aggregate Processing" },
        CPA: { code: "38.21", description: "Materials recovery services and secondary raw materials" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3821", description: "Treatment and disposal of non-hazardous waste" },
        NACE_level_4: { code: "38.21", description: "Materials recovery" },
        NACE_level_3: { code: "38.2", description: "Waste recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "38.21", description: "Treatment and disposal of non-hazardous waste" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Provender Mills (National Scheme)": {
        SCAT: { code: "222", description: "Provender Mills (National Scheme)" },
        CPA: { code: "10.91", description: "Prepared feeds for farm animals" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1080", description: "Manufacture of prepared animal feeds" },
        NACE_level_4: { code: "10.91", description: "Manufacture of prepared feeds for farm animals" },
        NACE_level_3: { code: "10.9", description: "Manufacture of prepared animal feeds" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.91", description: "Manufacture of prepared feeds for farm animals" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Public and Independent Schools (National Scheme)": {
        SCAT: { code: "223", description: "Public and Independent Schools (National Scheme)" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Public Conveniences (National Scheme)": {
        SCAT: { code: "224", description: "Public Conveniences (National Scheme)" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Public Halls": {
        SCAT: { code: "225", description: "Public Halls" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "F1(e)", description: "Public halls or exhibition halls" },
    },
    "Public Houses/Pub Restaurants (National Scheme)": {
        SCAT: { code: "226", description: "Public Houses/Pub Restaurants (National Scheme)" },
        CPA: { code: "56.30", description: "Beverage serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5630", description: "Beverage serving activities" },
        NACE_level_4: { code: "56.30", description: "Beverage serving activities" },
        NACE_level_3: { code: "56.3", description: "Beverage serving activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.30", description: "Beverage serving activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Public Houses/Pub Restaurants (Inc. Lodge) (National Scheme)": {
        SCAT: { code: "227", description: "Public Houses/Pub Restaurants (Inc. Lodge) (National Scheme)" },
        CPA: { code: "56.30", description: "Beverage serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5630", description: "Beverage serving activities" },
        NACE_level_4: { code: "56.30", description: "Beverage serving activities" },
        NACE_level_3: { code: "56.3", description: "Beverage serving activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.30", description: "Beverage serving activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Public Telephone Kiosks (National Scheme)": {
        SCAT: { code: "228", description: "Public Telephone Kiosks (National Scheme)" },
        CPA: { code: "61.90", description: "Other telecommunication services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "6190", description: "Other telecommunication activities" },
        NACE_level_4: { code: "61.90", description: "Other telecommunication activities" },
        NACE_level_3: { code: "61.9", description: "Other telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.90", description: "Other telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Racing Stables (National Scheme)": {
        SCAT: { code: "229", description: "Racing Stables (National Scheme)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "RAF Hereditaments": {
        SCAT: { code: "230", description: "RAF Hereditaments" },
        CPA: { code: "84.22", description: "Defence services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8422", description: "Defence activities" },
        NACE_level_4: { code: "84.22", description: "Defence activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.22", description: "Defence activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Railways & Tramways (Non Leisure)": {
        SCAT: { code: "231", description: "Railways & Tramways (Non Leisure)" },
        CPA: { code: "49.11", description: "Passenger heavy rail transport services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "4911", description: "Passenger rail transport, interurban" },
        NACE_level_4: { code: "49.11", description: "Passenger heavy rail transport" },
        NACE_level_3: { code: "49.1", description: "Passenger rail transport" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "49.10", description: "Passenger rail transport, interurban" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Recording Studios": {
        SCAT: { code: "232", description: "Recording Studios" },
        CPA: { code: "59.20", description: "Sound recording and music publishing services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "5920", description: "Sound recording and music publishing activities" },
        NACE_level_4: { code: "59.20", description: "Sound recording and music publishing activities" },
        NACE_level_3: { code: "59.2", description: "Sound recording and music publishing activities" },
        NACE_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        UK_SIC: { code: "59.20", description: "Sound recording and music publishing activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Refuse Destructor Plants/Disposal Sites": {
        SCAT: { code: "233", description: "Refuse Destructor Plants/Disposal Sites" },
        CPA: { code: "38.33", description: "Other waste disposal services" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3830", description: "Materials and other waste recovery" },
        NACE_level_4: { code: "38.33", description: "Other waste disposal" },
        NACE_level_3: { code: "38.3", description: "Waste disposal without recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "38.32", description: "Recovery of sorted materials" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Restaurants": {
        SCAT: { code: "234", description: "Restaurants" },
        CPA: { code: "56.11", description: "Restaurant serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.11", description: "Restaurant activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Retail Warehouses and Foodstores": {
        SCAT: { code: "235", description: "Retail Warehouses and Foodstores" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4711", description: "Non-specialized retail sale with food, beverages or tobacco predominating" },
        NACE_level_4: { code: "47.11", description: "Non-specialised retail sale of predominately food, beverages or tobacco" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.11", description: "Retail sale in non-specialised stores with food, beverages or tobacco predominating" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Riding Schools & Livery Stables (National Scheme)": {
        SCAT: { code: "236", description: "Riding Schools & Livery Stables (National Scheme)" },
        CPA: { code: "85.51", description: "Sports and recreation education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8551", description: "Sports and recreation education" },
        NACE_level_4: { code: "85.51", description: "Sports and recreation education" },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.51", description: "Sports and recreation education" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Rifle and Weapons Ranges": {
        SCAT: { code: "237", description: "Rifle and Weapons Ranges" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Roadside Restaurants (National Scheme)": {
        SCAT: { code: "238", description: "Roadside Restaurants (National Scheme)" },
        CPA: { code: "56.11", description: "Restaurant serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.11", description: "Restaurant activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Roller Skating Rinks": {
        SCAT: { code: "239", description: "Roller Skating Rinks" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Royal Palaces": {
        SCAT: { code: "240", description: "Royal Palaces" },
        CPA: { code: "91.22", description: "Historical site and monument services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9122", description: "Historical site and monument activities" },
        NACE_level_4: { code: "91.22", description: "Historical site and monument activities" },
        NACE_level_3: { code: "91.2", description: "Museum, collection, historical site and monument activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.03", description: "Operation of historical sites and buildings and similar visitor attractions" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Rugby League Grounds": {
        SCAT: { code: "241", description: "Rugby League Grounds" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Rugby Union Grounds": {
        SCAT: { code: "242", description: "Rugby Union Grounds" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Sales Kiosks": {
        SCAT: { code: "243", description: "Sales Kiosks" },
        CPA: { code: "47.92", description: "Intermediation services of retail sale services" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4790", description: "Intermediation service activities for retail sale" },
        NACE_level_4: { code: "47.91", description: "Intermediation service activities for non-specialised retail sale" },
        NACE_level_3: { code: "47.9", description: "Intermediation service activities for retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.91", description: "Retail sale via mail order houses or via Internet" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Scrap Metal/Breakers Yard": {
        SCAT: { code: "244", description: "Scrap Metal/Breakers Yard" },
        CPA: { code: "32.99", description: "Other manufactured goods n.e.c." },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3290", description: "Other manufacturing n.e.c." },
        NACE_level_4: { code: "32.99", description: "Other manufacturing n.e.c." },
        NACE_level_3: { code: "32.9", description: "Manufacturing not elsewhere classified" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "32.99", description: "Other manufacturing n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Sea Dredged Aggregate Processing Plants & Depots": {
        SCAT: { code: "245", description: "Sea Dredged Aggregate Processing Plants & Depots" },
        CPA: { code: "42.91", description: "Constructions and construction works for water projects" },
        ISIC_level_1: { code: "F", description: "Construction" },
        ISIC_level_4: { code: "4290", description: "Construction of other civil engineering projects" },
        NACE_level_4: { code: "42.91", description: "Construction of water projects" },
        NACE_level_3: { code: "42.9", description: "Construction of other civil engineering projects" },
        NACE_level_1: { code: "F", description: "Construction" },
        UK_SIC: { code: "42.91", description: "Construction of water projects" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Sewage Works (National Scheme)": {
        SCAT: { code: "246", description: "Sewage Works (National Scheme)" },
        CPA: { code: "37.00", description: "Sewerage services; sewage sludge" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3700", description: "Sewerage" },
        NACE_level_4: { code: "37.00", description: "Sewerage" },
        NACE_level_3: { code: "37.0", description: "Sewerage" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "37.00", description: "Sewerage" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Ship Building Yards": {
        SCAT: { code: "247", description: "Ship Building Yards" },
        CPA: { code: "30.11", description: "Civilian ships and floating structures" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3011", description: "Building of ships and floating structures" },
        NACE_level_4: { code: "30.11", description: "Building of civilian ships and floating structures" },
        NACE_level_3: { code: "30.1", description: "Building of ships and boats" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "30.11", description: "Building of ships and floating structures" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Ship Repair Yards": {
        SCAT: { code: "248", description: "Ship Repair Yards" },
        CPA: { code: "33.15", description: "Repair and maintenance services of civilian ships and boats" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "3315", description: "Repair and maintenance of transport equipment, except motor vehicles" },
        NACE_level_4: { code: "33.15", description: "Repair and maintenance of civilian ships and boats" },
        NACE_level_3: { code: "33.1", description: "Repair and maintenance of fabricated metal products, machinery and equipment" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "33.15", description: "Repair and maintenance of ships and boats" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Shops": {
        SCAT: { code: "249", description: "Shops" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Showhouses (National Scheme)": {
        SCAT: { code: "250", description: "Showhouses (National Scheme)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Showrooms": {
        SCAT: { code: "251", description: "Showrooms" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Ski Centres": {
        SCAT: { code: "252", description: "Ski Centres" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Snooker Halls/Clubs": {
        SCAT: { code: "253", description: "Snooker Halls/Clubs" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Speedway Racetracks": {
        SCAT: { code: "254", description: "Speedway Racetracks" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Spoil Heap Workings": {
        SCAT: { code: "255", description: "Spoil Heap Workings" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Sporting Rights": {
        SCAT: { code: "256", description: "Sporting Rights" },
        CPA: { code: "93.12", description: "Services of sports clubs" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9312", description: "Activities of sports clubs" },
        NACE_level_4: { code: "93.12", description: "Activities of sports clubs" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.12", description: "Activities of sport clubs" },
        planning_classes: { code: "N/A", description: "" },
    },
    "Sports & Leisure Centres (LA) (Dry Only) (National Scheme)": {
        SCAT: { code: "257", description: "Sports & Leisure Centres (LA) (Dry Only) (National Scheme)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Sports & Leisure Centres (LA) (Wet & Dry) (National Scheme)": {
        SCAT: { code: "258", description: "Sports & Leisure Centres (LA) (Wet & Dry) (National Scheme)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Sports & Leisure Centres (Private)(Dry Only)": {
        SCAT: { code: "259", description: "Sports & Leisure Centres (Private)(Dry Only)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Sports & Leisure Centres (Private)(Wet & Dry)": {
        SCAT: { code: "260", description: "Sports & Leisure Centres (Private)(Wet & Dry)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Sports Grounds": {
        SCAT: { code: "261", description: "Sports Grounds" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Sports Stadia": {
        SCAT: { code: "262", description: "Sports Stadia" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Squash Courts": {
        SCAT: { code: "263", description: "Squash Courts" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Stables and Loose Boxes": {
        SCAT: { code: "264", description: "Stables and Loose Boxes" },
        CPA: { code: "01.43", description: "Horses and other equines, live" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0143", description: "Raising of camels and camelids" },
        NACE_level_4: { code: "01.43", description: "Raising of horses and other equines" },
        NACE_level_3: { code: "01.4", description: "Animal production" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.43", description: "Raising of horses and other equines" },
        planning_classes: { code: "", description: "" },
    },
    "Stately Homes & Historic Houses (National Scheme)": {
        SCAT: { code: "265", description: "Stately Homes & Historic Houses (National Scheme)" },
        CPA: { code: "91.22", description: "Historical site and monument services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9122", description: "Historical site and monument activities" },
        NACE_level_4: { code: "91.22", description: "Historical site and monument activities" },
        NACE_level_3: { code: "91.2", description: "Museum, collection, historical site and monument activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.03", description: "Operation of historical sites and buildings and similar visitor attractions" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Station Let Outs": {
        SCAT: { code: "266", description: "Station Let Outs" },
        CPA: { code: "68.20", description: "Rental and operating services of own or leased real estate" },
        ISIC_level_1: { code: "M", description: "Real estate activities" },
        ISIC_level_4: { code: "6821", description: "Intermediation service activities for real estate" },
        NACE_level_4: { code: "68.20", description: "Rental and operating of own or leased real estate" },
        NACE_level_3: { code: "68.2", description: "Rental and operating of own or leased real estate" },
        NACE_level_1: { code: "M", description: "Real estate activities" },
        UK_SIC: { code: "68.20", description: "Renting and operating of own or leased real estate" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Storage Depots": {
        SCAT: { code: "267", description: "Storage Depots" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Stores": {
        SCAT: { code: "268", description: "Stores" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Stud Farms": {
        SCAT: { code: "269", description: "Stud Farms" },
        CPA: { code: "01.43", description: "Horses and other equines, live" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0143", description: "Raising of camels and camelids" },
        NACE_level_4: { code: "01.43", description: "Raising of horses and other equines" },
        NACE_level_3: { code: "01.4", description: "Animal production" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.43", description: "Raising of horses and other equines" },
        planning_classes: { code: "", description: "" },
    },
    "Studios": {
        SCAT: { code: "270", description: "Studios" },
        CPA: { code: "96.99", description: "Other personal services n.e.c." },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9690", description: "Other personal service activities n.e.c." },
        NACE_level_4: { code: "96.99", description: "Other personal service activities n.e.c." },
        NACE_level_3: { code: "96.9", description: "Other personal service activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Surgeries, Clinics, Health Centre (incl Dentists etc)": {
        SCAT: { code: "271", description: "Surgeries, Clinics, Health Centre (incl Dentists etc)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Swimming Pools (Local Authority)": {
        SCAT: { code: "272", description: "Swimming Pools (Local Authority)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(d)", description: "Indoor or outdoor swimming pools or skating rinks" },
    },
    "Swimming Pools (Private)": {
        SCAT: { code: "273", description: "Swimming Pools (Private)" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(d)", description: "Indoor or outdoor swimming pools or skating rinks" },
    },
    "Tanneries": {
        SCAT: { code: "274", description: "Tanneries" },
        CPA: { code: "15.11", description: "Tanned, dressed, dyed leather and fur" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1511", description: "Tanning and dressing of leather; dressing and dyeing of fur" },
        NACE_level_4: { code: "15.11", description: "Tanning, dressing, dyeing of leather and fur" },
        NACE_level_3: { code: "15.1", description: "Tanning, dyeing, dressing of leather and fur; manufacture of luggage, handbags, saddlery and harness" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "15.11", description: "Tanning and dressing of leather; dressing and dyeing of fur" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Telecommunications Cable Networks (National Scheme)": {
        SCAT: { code: "275", description: "Telecommunications Cable Networks (National Scheme)" },
        CPA: { code: "61.10", description: "Wired, wireless, and satellite telecommunication services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "6110", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_4: { code: "61.10", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_3: { code: "61.1", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.10", description: "Wired telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Telecommunications Switching Centres": {
        SCAT: { code: "276", description: "Telecommunications Switching Centres" },
        CPA: { code: "61.10", description: "Wired, wireless, and satellite telecommunication services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "6110", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_4: { code: "61.10", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_3: { code: "61.1", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.10", description: "Wired telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Tennis Centres": {
        SCAT: { code: "277", description: "Tennis Centres" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Tennis Courts/Clubs": {
        SCAT: { code: "278", description: "Tennis Courts/Clubs" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Theatres (National Scheme)": {
        SCAT: { code: "279", description: "Theatres (National Scheme)" },
        CPA: { code: "90.31", description: "Operation services of arts facilities and sites" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9031", description: "Operation of arts facilities and sites" },
        NACE_level_4: { code: "90.31", description: "Operation of arts facilities and sites" },
        NACE_level_3: { code: "90.3", description: "Support activities to arts creation and performing arts" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "90.04", description: "Operation of arts facilities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Theme Parks": {
        SCAT: { code: "280", description: "Theme Parks" },
        CPA: { code: "93.21", description: "Amusement park and theme park services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9321", description: "Activities of amusement parks and theme parks" },
        NACE_level_4: { code: "93.21", description: "Activities of amusement parks and theme parks" },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.21", description: "Activities of amusement parks and theme parks" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Timeshare Complexes (National Scheme)": {
        SCAT: { code: "281", description: "Timeshare Complexes (National Scheme)" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Tolls (Ferries, Roads And Bridges)": {
        SCAT: { code: "282", description: "Tolls (Ferries, Roads And Bridges)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Totalisators On Horse Racecourses": {
        SCAT: { code: "283", description: "Totalisators On Horse Racecourses" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Tourist Attractions/Dark Rides": {
        SCAT: { code: "284", description: "Tourist Attractions/Dark Rides" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Training Centre (Non Residential)": {
        SCAT: { code: "285", description: "Training Centre (Non Residential)" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Training Centre (Residential)": {
        SCAT: { code: "286", description: "Training Centre (Residential)" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Truck Stops": {
        SCAT: { code: "287", description: "Truck Stops" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Universities (Excluding Oxbridge) (National Scheme)": {
        SCAT: { code: "288", description: "Universities (Excluding Oxbridge) (National Scheme)" },
        CPA: { code: "85.40", description: "Tertiary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8540", description: "Tertiary education" },
        NACE_level_4: { code: "85.40", description: "Tertiary education" },
        NACE_level_3: { code: "85.4", description: "Tertiary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.42", description: "Tertiary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Vehicle Repair Workshops & Garages": {
        SCAT: { code: "289", description: "Vehicle Repair Workshops & Garages" },
        CPA: { code: "95.31", description: "Repair and maintenance services of motor vehicles" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9531", description: "Repair and maintenance of motor vehicles" },
        NACE_level_4: { code: "95.31", description: "Repair and maintenance of motor vehicles" },
        NACE_level_3: { code: "95.3", description: "Repair and maintenance of motor vehicles and motorcycles" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "95.29", description: "Repair of other personal and household goods" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Vehicle Testing Centres (With Test Tracks)": {
        SCAT: { code: "290", description: "Vehicle Testing Centres (With Test Tracks)" },
        CPA: { code: "71.20", description: "Technical testing and analysis services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7120", description: "Technical testing and analysis" },
        NACE_level_4: { code: "71.20", description: "Technical testing and analysis" },
        NACE_level_3: { code: "71.2", description: "Technical testing and analysis" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "71.20", description: "Technical testing and analysis" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "Vehicle Testing Centres (Without Test Tracks)": {
        SCAT: { code: "291", description: "Vehicle Testing Centres (Without Test Tracks)" },
        CPA: { code: "71.20", description: "Technical testing and analysis services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7120", description: "Technical testing and analysis" },
        NACE_level_4: { code: "71.20", description: "Technical testing and analysis" },
        NACE_level_3: { code: "71.2", description: "Technical testing and analysis" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "71.20", description: "Technical testing and analysis" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "Veterinary Clinics / Animal Clinics": {
        SCAT: { code: "292", description: "Veterinary Clinics / Animal Clinics" },
        CPA: { code: "75.00", description: "Veterinary services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7500", description: "Veterinary activities" },
        NACE_level_4: { code: "75.00", description: "Veterinary activities" },
        NACE_level_3: { code: "75.0", description: "Veterinary activities" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "75.00", description: "Veterinary activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Village Halls, Scout Huts, Cadet Huts Etc": {
        SCAT: { code: "293", description: "Village Halls, Scout Huts, Cadet Huts Etc" },
        CPA: { code: "94.99", description: "Services furnished by other membership organisations n.e.c." },
        ISIC_level_1: { code: "T", description: "Other service activities" },
        ISIC_level_4: { code: "9499", description: "Activities of other membership organizations n.e.c." },
        NACE_level_4: { code: "94.99", description: "Activities of other membership organisations n.e.c." },
        NACE_level_3: { code: "94.9", description: "Activities of other membership organisations" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "94.99", description: "Activities of other membership organisations n.e.c." },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Vineyards/Wineries": {
        SCAT: { code: "294", description: "Vineyards/Wineries" },
        CPA: { code: "01.21", description: "Fresh grapes" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0121", description: "Growing of grapes" },
        NACE_level_4: { code: "01.21", description: "Growing of grapes" },
        NACE_level_3: { code: "01.2", description: "Growing of perennial crops" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.21", description: "Growing of grapes" },
        planning_classes: { code: "", description: "" },
    },
    "Wafer Fabrications (National Scheme)": {
        SCAT: { code: "295", description: "Wafer Fabrications (National Scheme)" },
        CPA: { code: "26.11", description: "Electronic components" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2611", description: "Manufacture of solar cells, solar panels and photovoltaic inverters" },
        NACE_level_4: { code: "26.11", description: "Manufacture of electronic components" },
        NACE_level_3: { code: "26.1", description: "Manufacture of electronic components and boards" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "26.11", description: "Manufacture of electronic components" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "War Games Courses/Misc Ag. Use": {
        SCAT: { code: "296", description: "War Games Courses/Misc Ag. Use" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Waste Incinerator Plants": {
        SCAT: { code: "297", description: "Waste Incinerator Plants" },
        CPA: { code: "38.31", description: "Incineration services without energy recovery" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3900", description: "Remediation and other waste management service activities" },
        NACE_level_4: { code: "38.31", description: "Incineration without energy recovery" },
        NACE_level_3: { code: "38.3", description: "Waste disposal without recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "39.00", description: "Remediation activities and other waste management services" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Waste Recycling Plants": {
        SCAT: { code: "298", description: "Waste Recycling Plants" },
        CPA: { code: "38.21", description: "Materials recovery services and secondary raw materials" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3821", description: "Treatment and disposal of non-hazardous waste" },
        NACE_level_4: { code: "38.21", description: "Materials recovery" },
        NACE_level_3: { code: "38.2", description: "Waste recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "38.21", description: "Treatment and disposal of non-hazardous waste" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Waste Transfer Stations": {
        SCAT: { code: "299", description: "Waste Transfer Stations" },
        CPA: { code: "38.31", description: "Incineration services without energy recovery" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3900", description: "Remediation and other waste management service activities" },
        NACE_level_4: { code: "38.31", description: "Incineration without energy recovery" },
        NACE_level_3: { code: "38.3", description: "Waste disposal without recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "39.00", description: "Remediation activities and other waste management services" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Water Undertakings (Non-Statutory)": {
        SCAT: { code: "300", description: "Water Undertakings (Non-Statutory)" },
        CPA: { code: "36.00", description: "Natural water; water treatment and supply services" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3600", description: "Water collection, treatment and supply" },
        NACE_level_4: { code: "36.00", description: "Water collection, treatment and supply" },
        NACE_level_3: { code: "36.0", description: "Water collection, treatment and supply" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "36.00", description: "Water collection, treatment and supply" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Wholesale Warehouses": {
        SCAT: { code: "301", description: "Wholesale Warehouses" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Windmills": {
        SCAT: { code: "302", description: "Windmills" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Wine Bars": {
        SCAT: { code: "303", description: "Wine Bars" },
        CPA: { code: "56.30", description: "Beverage serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5630", description: "Beverage serving activities" },
        NACE_level_4: { code: "56.30", description: "Beverage serving activities" },
        NACE_level_3: { code: "56.3", description: "Beverage serving activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.30", description: "Beverage serving activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Zoos & Safari Parks": {
        SCAT: { code: "304", description: "Zoos & Safari Parks" },
        CPA: { code: "91.41", description: "Botanical and zoological garden services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9141", description: "Botanical and zoological garden activities" },
        NACE_level_4: { code: "91.41", description: "Botanical and zoological garden activities" },
        NACE_level_3: { code: "91.4", description: "Botanical and zoological garden and nature reserve activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.04", description: "Botanical and zoological gardens and nature reserve activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Abattoirs & Slaughter Houses (Contractors Valuation)": {
        SCAT: { code: "400", description: "Abattoirs & Slaughter Houses (Contractors Valuation)" },
        CPA: { code: "10.13", description: "Preserves and preparations of meat, meat offal or blood" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1010", description: "Processing and preserving of meat" },
        NACE_level_4: { code: "10.13", description: "Production of meat and poultry meat products" },
        NACE_level_3: { code: "10.1", description: "Processing and preserving of meat and production of meat products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.13", description: "Production of meat and poultry meat products" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Abattoirs & Slaughter Houses (Rental Valuation)": {
        SCAT: { code: "401", description: "Abattoirs & Slaughter Houses (Rental Valuation)" },
        CPA: { code: "10.13", description: "Preserves and preparations of meat, meat offal or blood" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "1010", description: "Processing and preserving of meat" },
        NACE_level_4: { code: "10.13", description: "Production of meat and poultry meat products" },
        NACE_level_3: { code: "10.1", description: "Processing and preserving of meat and production of meat products" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "10.13", description: "Production of meat and poultry meat products" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Agricultural Research Centres": {
        SCAT: { code: "402", description: "Agricultural Research Centres" },
        CPA: { code: "72.10", description: "Research and development services on natural sciences, engineering and technology" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7210", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_4: { code: "72.10", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_3: { code: "72.1", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "72.19", description: "Other research and experimental development on natural sciences and engineering" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "Aquaria": {
        SCAT: { code: "403", description: "Aquaria" },
        CPA: { code: "91.41", description: "Botanical and zoological garden services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9141", description: "Botanical and zoological garden activities" },
        NACE_level_4: { code: "91.41", description: "Botanical and zoological garden activities" },
        NACE_level_3: { code: "91.4", description: "Botanical and zoological garden and nature reserve activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.04", description: "Botanical and zoological gardens and nature reserve activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Archives": {
        SCAT: { code: "404", description: "Archives" },
        CPA: { code: "91.12", description: "Archive services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "9112", description: "Archives activities" },
        NACE_level_4: { code: "91.12", description: "Archive activities" },
        NACE_level_3: { code: "91.1", description: "Library and archive activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.01", description: "Library and archive activities" },
        planning_classes: { code: "F1(d)", description: "Public libraries or public reading rooms" },
    },
    "Boathouses": {
        SCAT: { code: "405", description: "Boathouses" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Bus Garages (Contractors Valuation)": {
        SCAT: { code: "406", description: "Bus Garages (Contractors Valuation)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Bus Garages (Rental Valuation)": {
        SCAT: { code: "407", description: "Bus Garages (Rental Valuation)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Business Units": {
        SCAT: { code: "408", description: "Business Units" },
        CPA: { code: "82.10", description: "Office administrative and support services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8210", description: "Office administrative and support activities" },
        NACE_level_4: { code: "82.10", description: "Office administrative and support activities" },
        NACE_level_3: { code: "82.1", description: "Office administrative and support activities" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.11", description: "Combined office administrative service activities" },
        planning_classes: { code: "E(g)(i)", description: "Offices to carry out any operational or administrative functions" },
    },
    "Cafes": {
        SCAT: { code: "409", description: "Cafes" },
        CPA: { code: "56.30", description: "Beverage serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5630", description: "Beverage serving activities" },
        NACE_level_4: { code: "56.30", description: "Beverage serving activities" },
        NACE_level_3: { code: "56.3", description: "Beverage serving activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.30", description: "Beverage serving activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Changing Rooms": {
        SCAT: { code: "410", description: "Changing Rooms" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Coastguard Stations": {
        SCAT: { code: "411", description: "Coastguard Stations" },
        CPA: { code: "84.24", description: "Public order and safety services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.24", description: "Public order and safety activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.24", description: "Public order and safety activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Cold Stores (Contractors Valuation)": {
        SCAT: { code: "412", description: "Cold Stores (Contractors Valuation)" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Cold Stores (Rental Valuation)": {
        SCAT: { code: "413", description: "Cold Stores (Rental Valuation)" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Courts (Contractors Valuation)": {
        SCAT: { code: "414", description: "Courts (Contractors Valuation)" },
        CPA: { code: "84.23", description: "Justice and judicial services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.23", description: "Justice and judicial activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.23", description: "Justice and judicial activities" },
        planning_classes: { code: "F1(g)", description: "Law courts" },
    },
    "Courts (Rental Valuation)": {
        SCAT: { code: "415", description: "Courts (Rental Valuation)" },
        CPA: { code: "84.23", description: "Justice and judicial services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.23", description: "Justice and judicial activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.23", description: "Justice and judicial activities" },
        planning_classes: { code: "F1(g)", description: "Law courts" },
    },
    "Gymnasia/Fitness Suites": {
        SCAT: { code: "416", description: "Gymnasia/Fitness Suites" },
        CPA: { code: "93.13", description: "Services of fitness centres" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.13", description: "Activities of fitness centres" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.13", description: "Fitness facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Hairdressing/Beauty Salons": {
        SCAT: { code: "417", description: "Hairdressing/Beauty Salons" },
        CPA: { code: "96.22", description: "Beauty care and other beauty treatment services" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9622", description: "Beauty care and other beauty treatment activities" },
        NACE_level_4: { code: "96.22", description: "Beauty care and other beauty treatment activities" },
        NACE_level_3: { code: "96.2", description: "Hairdressing, beauty treatment, day spa and similar activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "E(c)(ii)", description: "Professional services (other than health or medical services)" },
    },
    "Information/Visitor Centres": {
        SCAT: { code: "418", description: "Information/Visitor Centres" },
        CPA: { code: "82.10", description: "Office administrative and support services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8210", description: "Office administrative and support activities" },
        NACE_level_4: { code: "82.10", description: "Office administrative and support activities" },
        NACE_level_3: { code: "82.1", description: "Office administrative and support activities" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.11", description: "Combined office administrative service activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Land Used for Display": {
        SCAT: { code: "419", description: "Land Used for Display" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Lifeboat Stations": {
        SCAT: { code: "420", description: "Lifeboat Stations" },
        CPA: { code: "84.24", description: "Public order and safety services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8423", description: "Public order and safety activities" },
        NACE_level_4: { code: "84.24", description: "Public order and safety activities" },
        NACE_level_3: { code: "84.2", description: "Provision of services to the community as a whole" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.24", description: "Public order and safety activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Miniature Railways": {
        SCAT: { code: "421", description: "Miniature Railways" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Pack Houses": {
        SCAT: { code: "422", description: "Pack Houses" },
        CPA: { code: "82.92", description: "Packaging services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8292", description: "Packaging activities" },
        NACE_level_4: { code: "82.92", description: "Packaging activities" },
        NACE_level_3: { code: "82.9", description: "Business support service activities not elsewhere classified" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.92", description: "Packaging activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Peat Fields": {
        SCAT: { code: "423", description: "Peat Fields" },
        CPA: { code: "08.92", description: "Peat" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0892", description: "Extraction of peat" },
        NACE_level_4: { code: "08.92", description: "Extraction of peat" },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.92", description: "Extraction of peat" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Pet Grooming Parlours": {
        SCAT: { code: "424", description: "Pet Grooming Parlours" },
        CPA: { code: "96.99", description: "Other personal services n.e.c." },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9690", description: "Other personal service activities n.e.c." },
        NACE_level_4: { code: "96.99", description: "Other personal service activities n.e.c." },
        NACE_level_3: { code: "96.9", description: "Other personal service activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Pharmacies Within/Adjacent to Surgery/Health Centre": {
        SCAT: { code: "425", description: "Pharmacies Within/Adjacent to Surgery/Health Centre" },
        CPA: { code: "47.73", description: "Retail sale services of pharmaceutical products" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4773", description: "Retail sale of other new goods n.e.c." },
        NACE_level_4: { code: "47.73", description: "Retail sale of pharmaceutical products" },
        NACE_level_3: { code: "47.7", description: "Retail sale of other goods, except motor vehicles and motorcycles" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.73", description: "Dispensing chemist in specialised stores" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Pitch and Putt/Putting Greens": {
        SCAT: { code: "426", description: "Pitch and Putt/Putting Greens" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Pitches for Stalls, Sales or Promotions": {
        SCAT: { code: "427", description: "Pitches for Stalls, Sales or Promotions" },
        CPA: { code: "47.92", description: "Intermediation services of retail sale services" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4790", description: "Intermediation service activities for retail sale" },
        NACE_level_4: { code: "47.91", description: "Intermediation service activities for non-specialised retail sale" },
        NACE_level_3: { code: "47.9", description: "Intermediation service activities for retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.91", description: "Retail sale via mail order houses or via Internet" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Police Training Colleges": {
        SCAT: { code: "428", description: "Police Training Colleges" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Post Offices": {
        SCAT: { code: "429", description: "Post Offices" },
        CPA: { code: "53.10", description: "Postal services under universal service obligation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5310", description: "Postal activities" },
        NACE_level_4: { code: "53.10", description: "Postal activities under universal service obligation" },
        NACE_level_3: { code: "53.1", description: "Postal activities under universal service obligation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "53.10", description: "Postal activities under universal service obligation" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Pumping Mines": {
        SCAT: { code: "430", description: "Pumping Mines" },
        CPA: { code: "09.90", description: "Support services to other mining and quarrying" },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0990", description: "Support activities for other mining and quarrying" },
        NACE_level_4: { code: "09.90", description: "Support activities for other mining and quarrying" },
        NACE_level_3: { code: "09.9", description: "Support activities for other mining and quarrying" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "09.90", description: "Support activities for other mining and quarrying" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Religious Retreats/Study Centres (Residential)": {
        SCAT: { code: "431", description: "Religious Retreats/Study Centres (Residential)" },
        CPA: { code: "94.91", description: "Services furnished by religious organisations" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9491", description: "Activities of religious organizations" },
        NACE_level_4: { code: "94.91", description: "Activities of religious organisations" },
        NACE_level_3: { code: "94.9", description: "Activities of other membership organisations" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "94.91", description: "Activities of religious organisations" },
        planning_classes: { code: "F1(f)", description: "Public worship or religious instruction (or in connection with such use)" },
    },
    "Sales Offices": {
        SCAT: { code: "432", description: "Sales Offices" },
        CPA: { code: "82.10", description: "Office administrative and support services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8210", description: "Office administrative and support activities" },
        NACE_level_4: { code: "82.10", description: "Office administrative and support activities" },
        NACE_level_3: { code: "82.1", description: "Office administrative and support activities" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.11", description: "Combined office administrative service activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Statutory Docks and Harbours (Formula)": {
        SCAT: { code: "433", description: "Statutory Docks and Harbours (Formula)" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Statutory Docks and Harbours (Non- Formula, Prescribed)": {
        SCAT: { code: "434", description: "Statutory Docks and Harbours (Non- Formula, Prescribed)" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Statutory Docks and Harbours (Other)": {
        SCAT: { code: "435", description: "Statutory Docks and Harbours (Other)" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Surgeries, Clinics, Health Centres (Contractors Valuation)": {
        SCAT: { code: "436", description: "Surgeries, Clinics, Health Centres (Contractors Valuation)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Surgeries, Clinics, Health Centres (Rental Valuation)": {
        SCAT: { code: "437", description: "Surgeries, Clinics, Health Centres (Rental Valuation)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Telescope Sites": {
        SCAT: { code: "438", description: "Telescope Sites" },
        CPA: { code: "72.10", description: "Research and development services on natural sciences, engineering and technology" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7210", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_4: { code: "72.10", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_3: { code: "72.1", description: "Research and experimental development on natural sciences and engineering" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "72.19", description: "Other research and experimental development on natural sciences and engineering" },
        planning_classes: { code: "E(g)(ii)", description: "Research and development of products or processes" },
    },
    "University - Ancillary Land or Buildings": {
        SCAT: { code: "439", description: "University - Ancillary Land or Buildings" },
        CPA: { code: "85.40", description: "Tertiary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8540", description: "Tertiary education" },
        NACE_level_4: { code: "85.40", description: "Tertiary education" },
        NACE_level_3: { code: "85.4", description: "Tertiary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.42", description: "Tertiary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "University Occupation Within Hospitals": {
        SCAT: { code: "440", description: "University Occupation Within Hospitals" },
        CPA: { code: "85.40", description: "Tertiary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8540", description: "Tertiary education" },
        NACE_level_4: { code: "85.40", description: "Tertiary education" },
        NACE_level_3: { code: "85.4", description: "Tertiary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.42", description: "Tertiary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Weighbridges": {
        SCAT: { code: "441", description: "Weighbridges" },
        CPA: { code: "52.24", description: "Cargo handling services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5224", description: "Cargo handling" },
        NACE_level_4: { code: "52.24", description: "Cargo handling" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.24", description: "Cargo handling" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Takeaway Food Outlet (Predominantly Off Premises)": {
        SCAT: { code: "442", description: "Takeaway Food Outlet (Predominantly Off Premises)" },
        CPA: { code: "56.12", description: "Mobile food serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.12", description: "Mobile food service activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Cafes/Restaurants Within/Part of Specialist Property": {
        SCAT: { code: "500", description: "Cafes/Restaurants Within/Part of Specialist Property" },
        CPA: { code: "56.30", description: "Beverage serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5630", description: "Beverage serving activities" },
        NACE_level_4: { code: "56.30", description: "Beverage serving activities" },
        NACE_level_3: { code: "56.3", description: "Beverage serving activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.30", description: "Beverage serving activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Car Parking Within/Part of Specialist Property": {
        SCAT: { code: "501", description: "Car Parking Within/Part of Specialist Property" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Garages Within/Part of Specialist Property": {
        SCAT: { code: "502", description: "Garages Within/Part of Specialist Property" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Gymnasia/Fitness Suites Within/Part of Specialist Property": {
        SCAT: { code: "503", description: "Gymnasia/Fitness Suites Within/Part of Specialist Property" },
        CPA: { code: "93.13", description: "Services of fitness centres" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.13", description: "Activities of fitness centres" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.13", description: "Fitness facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Kiosks Within/Part of Specialist Property": {
        SCAT: { code: "504", description: "Kiosks Within/Part of Specialist Property" },
        CPA: { code: "47.92", description: "Intermediation services of retail sale services" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4790", description: "Intermediation service activities for retail sale" },
        NACE_level_4: { code: "47.91", description: "Intermediation service activities for non-specialised retail sale" },
        NACE_level_3: { code: "47.9", description: "Intermediation service activities for retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.91", description: "Retail sale via mail order houses or via Internet" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Nurseries/Creches Within/Part of Specialist Property": {
        SCAT: { code: "505", description: "Nurseries/Creches Within/Part of Specialist Property" },
        CPA: { code: "85.10", description: "Pre-primary education services" },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8510", description: "Pre-primary education" },
        NACE_level_4: { code: "85.10", description: "Pre-primary education" },
        NACE_level_3: { code: "85.1", description: "Pre-primary education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.10", description: "Pre-primary education" },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Offices Within/Part of Specialist Property": {
        SCAT: { code: "506", description: "Offices Within/Part of Specialist Property" },
        CPA: { code: "82.10", description: "Office administrative and support services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8210", description: "Office administrative and support activities" },
        NACE_level_4: { code: "82.10", description: "Office administrative and support activities" },
        NACE_level_3: { code: "82.1", description: "Office administrative and support activities" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.11", description: "Combined office administrative service activities" },
        planning_classes: { code: "E(g)(i)", description: "Offices to carry out any operational or administrative functions" },
    },
    "Salons/Clinics Within/Part of Specialist Property": {
        SCAT: { code: "507", description: "Salons/Clinics Within/Part of Specialist Property" },
        CPA: { code: "96.22", description: "Beauty care and other beauty treatment services" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9622", description: "Beauty care and other beauty treatment activities" },
        NACE_level_4: { code: "96.22", description: "Beauty care and other beauty treatment activities" },
        NACE_level_3: { code: "96.2", description: "Hairdressing, beauty treatment, day spa and similar activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "E(c)(ii)", description: "Professional services (other than health or medical services)" },
    },
    "Shops Within/Part of Specialist Property": {
        SCAT: { code: "508", description: "Shops Within/Part of Specialist Property" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(c)(ii)", description: "Professional services (other than health or medical services)" },
    },
    "Sports & Leisure Centres Within/Part of Specialist Property": {
        SCAT: { code: "509", description: "Sports & Leisure Centres Within/Part of Specialist Property" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "E(d)", description: "Indoor sport, recreation or fitness (not involving motorised vehicles or firearms or use as a swimming pool or skating rink,)" },
    },
    "Stores Within/Part of Specialist Property": {
        SCAT: { code: "510", description: "Stores Within/Part of Specialist Property" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(c)(ii)", description: "Professional services (other than health or medical services)" },
    },
    "Warehouses Within/Part of Specialist Property": {
        SCAT: { code: "511", description: "Warehouses Within/Part of Specialist Property" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Workshops Within/Part of Specialist Property": {
        SCAT: { code: "512", description: "Workshops Within/Part of Specialist Property" },
        CPA: { code: "25.63", description: "Tools" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "2593", description: "Manufacture of cutlery, hand tools and general hardware" },
        NACE_level_4: { code: "25.63", description: "Manufacture of tools" },
        NACE_level_3: { code: "25.6", description: "Manufacture of cutlery, tools and general hardware" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "25.73", description: "Manufacture of tools" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Miscellaneous Within/Part of Specialist Property": {
        SCAT: { code: "513", description: "Miscellaneous Within/Part of Specialist Property" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "T", description: "Other service activities" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_3: { code: "", description: "missing entry in classification" },
        NACE_level_1: { code: "", description: "missing entry in classification" },
        UK_SIC: { code: "", description: "missing entry in classification" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Sponsored Roundabout Advertising Displays": {
        SCAT: { code: "700", description: "Sponsored Roundabout Advertising Displays" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Restaurant With Letting Accomodation": {
        SCAT: { code: "701", description: "Restaurant With Letting Accomodation" },
        CPA: { code: "56.11", description: "Restaurant serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5610", description: "Restaurants and mobile food service activities" },
        NACE_level_4: { code: "56.11", description: "Restaurant activities" },
        NACE_level_3: { code: "56.1", description: "Restaurants and mobile food service activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.10", description: "Restaurants and mobile food service activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Driving Standards Agency Centre": {
        SCAT: { code: "702", description: "Driving Standards Agency Centre" },
        CPA: { code: "74.99", description: "All other professional, scientific and technical services n.e.c." },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7499", description: "All other professional, scientific and technical activities n.e.c." },
        NACE_level_4: { code: "74.99", description: "All other professional, scientific and technical activities n.e.c." },
        NACE_level_3: { code: "74.9", description: "Other professional, scientific and technical activities not elsewhere classified" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "74.90", description: "Other professional, scientific and technical activities n.e.c." },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Residual Shopping Mall": {
        SCAT: { code: "703", description: "Residual Shopping Mall" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Land Used For Seasonal Markets & Events": {
        SCAT: { code: "704", description: "Land Used For Seasonal Markets & Events" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Market Stall (Not Pitch)": {
        SCAT: { code: "705", description: "Market Stall (Not Pitch)" },
        CPA: { code: "47.92", description: "Intermediation services of retail sale services" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4790", description: "Intermediation service activities for retail sale" },
        NACE_level_4: { code: "47.91", description: "Intermediation service activities for non-specialised retail sale" },
        NACE_level_3: { code: "47.9", description: "Intermediation service activities for retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.89", description: "Retail sale via stalls and markets of other goods" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Advertising Displays On Pavements & Bus Shelters": {
        SCAT: { code: "706", description: "Advertising Displays On Pavements & Bus Shelters" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Advertising Displays At Superstores": {
        SCAT: { code: "707", description: "Advertising Displays At Superstores" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Advertising Displays From Phone Booths": {
        SCAT: { code: "708", description: "Advertising Displays From Phone Booths" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Dark Retailing/Internet Sites": {
        SCAT: { code: "709", description: "Dark Retailing/Internet Sites" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Residual Mall": {
        SCAT: { code: "710", description: "Residual Mall" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Advertising Displays From Agricultural Land": {
        SCAT: { code: "711", description: "Advertising Displays From Agricultural Land" },
        CPA: { code: "73.11", description: "Services provided by advertising agencies" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7310", description: "Advertising activities" },
        NACE_level_4: { code: "73.11", description: "Activities of advertising agencies" },
        NACE_level_3: { code: "73.1", description: "Advertising" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "73.11", description: "Advertising agencies" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Rail Freight Depots": {
        SCAT: { code: "712", description: "Rail Freight Depots" },
        CPA: { code: "49.20", description: "Freight rail transport services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "4923", description: "Freight transport by road" },
        NACE_level_4: { code: "49.20", description: "Freight rail transport" },
        NACE_level_3: { code: "49.2", description: "Freight rail transport" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "49.20", description: "Freight rail transport" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Bicycle Folding Box Site": {
        SCAT: { code: "713", description: "Bicycle Folding Box Site" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Rail Maintenance Depots": {
        SCAT: { code: "714", description: "Rail Maintenance Depots" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Football Training Grounds": {
        SCAT: { code: "715", description: "Football Training Grounds" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Cafe/Restaurants Within/Part of NonSpecialist Properties": {
        SCAT: { code: "716", description: "Cafe/Restaurants Within/Part of NonSpecialist Properties" },
        CPA: { code: "56.30", description: "Beverage serving services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5630", description: "Beverage serving activities" },
        NACE_level_4: { code: "56.30", description: "Beverage serving activities" },
        NACE_level_3: { code: "56.3", description: "Beverage serving activities" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "56.30", description: "Beverage serving activities" },
        planning_classes: { code: "E(b)", description: "Sale of food and drink for consumption (mostly) on the premises" },
    },
    "Delivery Box Site & Premises": {
        SCAT: { code: "717", description: "Delivery Box Site & Premises" },
        CPA: { code: "52.25", description: "Logistics services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5224", description: "Cargo handling?" },
        NACE_level_4: { code: "52.25", description: "Logistics service activities" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.24", description: "Cargo handling" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Electric Charge Stations": {
        SCAT: { code: "718", description: "Electric Charge Stations" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Car Washes (Stand Alone - Hand Car Wash)": {
        SCAT: { code: "719", description: "Car Washes (Stand Alone - Hand Car Wash)" },
        CPA: { code: "95.31", description: "Repair and maintenance services of motor vehicles" },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9531", description: "Repair and maintenance of motor vehicles" },
        NACE_level_4: { code: "95.31", description: "Repair and maintenance of motor vehicles" },
        NACE_level_3: { code: "95.3", description: "Repair and maintenance of motor vehicles and motorcycles" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "95.29", description: "Repair of other personal and household goods" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "LPG Service Station": {
        SCAT: { code: "720", description: "LPG Service Station" },
        CPA: { code: "47.30", description: "Retail sale services of automotive fuel" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4730", description: "Retail sale of automotive fuel" },
        NACE_level_4: { code: "47.30", description: "Retail sale of automotive fuel" },
        NACE_level_3: { code: "47.3", description: "Retail sale of automotive fuel" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.30", description: "Retail sale of automotive fuel in specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Self Storage Facility": {
        SCAT: { code: "721", description: "Self Storage Facility" },
        CPA: { code: "52.10", description: "Warehousing and storage services" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5210", description: "Warehousing and storage" },
        NACE_level_4: { code: "52.10", description: "Warehousing and storage" },
        NACE_level_3: { code: "52.1", description: "Warehousing and storage" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.10", description: "Warehousing and storage" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Serviced Appartments": {
        SCAT: { code: "722", description: "Serviced Appartments" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Serviced Offices": {
        SCAT: { code: "723", description: "Serviced Offices" },
        CPA: { code: "82.10", description: "Office administrative and support services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8210", description: "Office administrative and support activities" },
        NACE_level_4: { code: "82.10", description: "Office administrative and support activities" },
        NACE_level_3: { code: "82.1", description: "Office administrative and support activities" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.11", description: "Combined office administrative service activities" },
        planning_classes: { code: "E(g)(i)", description: "Offices to carry out any operational or administrative functions" },
    },
    "Street Points (eg Cycle Docking Stations)": {
        SCAT: { code: "724", description: "Street Points (eg Cycle Docking Stations)" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Park & Ride Car Parks": {
        SCAT: { code: "725", description: "Park & Ride Car Parks" },
        CPA: { code: "52.21", description: "Services incidental to land transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5221", description: "Service activities incidental to land transportation" },
        NACE_level_4: { code: "52.21", description: "Service activities incidental to land transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.21", description: "Service activities incidental to land transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Telecommunications Large Broadcast Sites": {
        SCAT: { code: "726", description: "Telecommunications Large Broadcast Sites" },
        CPA: { code: "61.10", description: "Wired, wireless, and satellite telecommunication services" },
        ISIC_level_1: { code: "J", description: "Publishing, broadcasting, and content production and distribution activities" },
        ISIC_level_4: { code: "6110", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_4: { code: "61.10", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_3: { code: "61.1", description: "Wired, wireless, and satellite telecommunication activities" },
        NACE_level_1: { code: "K", description: "Telecommunication, computer programming, consulting, computing infrastructure and other information service activities" },
        UK_SIC: { code: "61.10", description: "Wired telecommunications activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Waste Anaerobic Digestion Plants": {
        SCAT: { code: "727", description: "Waste Anaerobic Digestion Plants" },
        CPA: { code: "38.23", description: "Other waste recovery services" },
        ISIC_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        ISIC_level_4: { code: "3830", description: "Materials and other waste recovery" },
        NACE_level_4: { code: "38.23", description: "Other waste recovery" },
        NACE_level_3: { code: "38.2", description: "Waste recovery" },
        NACE_level_1: { code: "E", description: "Water supply; sewerage; waste managment and remediation activities" },
        UK_SIC: { code: "38.30", description: "Materials recovery" },
        planning_classes: { code: "B2", description: "General industrial" },
    },
    "Bagging Plant & Premises": {
        SCAT: { code: "728", description: "Bagging Plant & Premises" },
        CPA: { code: "82.92", description: "Packaging services" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "8292", description: "Packaging activities" },
        NACE_level_4: { code: "82.92", description: "Packaging activities" },
        NACE_level_3: { code: "82.9", description: "Business support service activities not elsewhere classified" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "82.92", description: "Packaging activities" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Renewable Generators - Mixed Technologies": {
        SCAT: { code: "729", description: "Renewable Generators - Mixed Technologies" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Biomass Biological (Crop & Slurry Based Anaerobic Digestors, Incl Gas to Grid)": {
        SCAT: { code: "730", description: "Biomass Biological (Crop & Slurry Based Anaerobic Digestors, Incl Gas to Grid)" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Biomass Thermal (Incl Combustion, Gasification and Pyrolysis)": {
        SCAT: { code: "731", description: "Biomass Thermal (Incl Combustion, Gasification and Pyrolysis)" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Click & Collect Locker Site": {
        SCAT: { code: "732", description: "Click & Collect Locker Site" },
        CPA: { code: "53.10", description: "Postal services under universal service obligation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5310", description: "Postal activities" },
        NACE_level_4: { code: "53.10", description: "Postal activities under universal service obligation" },
        NACE_level_3: { code: "53.1", description: "Postal activities under universal service obligation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "53.10", description: "Postal activities under universal service obligation" },
        planning_classes: { code: "B8", description: "Storage or distribution - This class includes open air storage" },
    },
    "Battery Store": {
        SCAT: { code: "733", description: "Battery Store" },
        CPA: { code: "47.27", description: "Retail sale services of other food" },
        ISIC_level_1: { code: "G", description: "Wholesale and retail trade" },
        ISIC_level_4: { code: "4719", description: "Other non-specialized retail sale" },
        NACE_level_4: { code: "47.12", description: "Other non-specialised retail sale" },
        NACE_level_3: { code: "47.1", description: "Non-specialised retail sale" },
        NACE_level_1: { code: "G", description: "Wholesale and retail trade" },
        UK_SIC: { code: "47.19", description: "Other retail sale in non-specialised stores" },
        planning_classes: { code: "E(a)", description: "Display or retail sale of goods, other than hot food" },
    },
    "Wedding and Function Venue": {
        SCAT: { code: "734", description: "Wedding and Function Venue" },
        CPA: { code: "96.99", description: "Other personal services n.e.c." },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9690", description: "Other personal service activities n.e.c." },
        NACE_level_4: { code: "96.99", description: "Other personal service activities n.e.c." },
        NACE_level_3: { code: "96.9", description: "Other personal service activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Historic Property (National Trust/English Heritage)": {
        SCAT: { code: "735", description: "Historic Property (National Trust/English Heritage)" },
        CPA: { code: "91.22", description: "Historical site and monument services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9122", description: "Historical site and monument activities" },
        NACE_level_4: { code: "91.22", description: "Historical site and monument activities" },
        NACE_level_3: { code: "91.2", description: "Museum, collection, historical site and monument activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "91.03", description: "Operation of historical sites and buildings and similar visitor attractions" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Holiday Home Self Catering (Complexs)": {
        SCAT: { code: "736", description: "Holiday Home Self Catering (Complexs)" },
        CPA: { code: "55.20", description: "Holiday and other short-stay accommodation services" },
        ISIC_level_1: { code: "I", description: "Accommodation and food service activities" },
        ISIC_level_4: { code: "5520", description: "Other short term accommodation activities" },
        NACE_level_4: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        NACE_level_3: { code: "55.2", description: "Holiday and other short-stay accommodation" },
        NACE_level_1: { code: "I", description: "Accommodation and food service activities" },
        UK_SIC: { code: "55.20", description: "Holiday and other short-stay accommodation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Ferry Terminal": {
        SCAT: { code: "737", description: "Ferry Terminal" },
        CPA: { code: "52.22", description: "Services incidental to water transportation" },
        ISIC_level_1: { code: "H", description: "Transportation and storage" },
        ISIC_level_4: { code: "5222", description: "Service activities incidental to water transportation" },
        NACE_level_4: { code: "52.22", description: "Service activities incidental to water transportation" },
        NACE_level_3: { code: "52.2", description: "Support activities for transportation" },
        NACE_level_1: { code: "H", description: "Transportation and storage" },
        UK_SIC: { code: "52.22", description: "Service activities incidental to water transportation" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Builders Merchant": {
        SCAT: { code: "738", description: "Builders Merchant" },
        CPA: { code: "77.32", description: "Rental and leasing services of construction and civil engineering machinery and equipment" },
        ISIC_level_1: { code: "O", description: "Administrative and support service activities" },
        ISIC_level_4: { code: "7730", description: "Rental and leasing of other machinery, equipment and tangible goods" },
        NACE_level_4: { code: "77.32", description: "Rental and leasing of construction and civil engineering machinery and equipment" },
        NACE_level_3: { code: "77.3", description: "Rental and leasing of other machinery, equipment and tangible goods" },
        NACE_level_1: { code: "O", description: "Administrative and support service activities" },
        UK_SIC: { code: "77.32", description: "Renting and leasing of construction and civil engineering machinery and equipment" },
        planning_classes: { code: "E(c)(ii)", description: "Professional services (other than health or medical services)" },
    },
    "Soccer Centres": {
        SCAT: { code: "739", description: "Soccer Centres" },
        CPA: { code: "93.11", description: "Sports facility operation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9311", description: "Operation of sports facilities" },
        NACE_level_4: { code: "93.11", description: "Operation of sports facilities" },
        NACE_level_3: { code: "93.1", description: "Sports activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.11", description: "Operation of sports facilities" },
        planning_classes: { code: "F2(c)", description: "Areas or places for outdoor sport or recreation (not involving motorised vehicles or firearms)" },
    },
    "Secure Childrens Homes": {
        SCAT: { code: "740", description: "Secure Childrens Homes" },
        CPA: { code: "87.99", description: "Other residential care services n.e.c." },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8799", description: "Other residential care activities n.e.c." },
        NACE_level_4: { code: "87.99", description: "Other residential care activities n.e.c." },
        NACE_level_3: { code: "87.9", description: "Other residential care activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "87.90", description: "Other residential care activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Independent Gas Transport (IGT)": {
        SCAT: { code: "741", description: "Independent Gas Transport (IGT)" },
        CPA: { code: "35.22", description: "Distribution services of gaseous fuels through mains" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3520", description: "Manufacture of gas; distribution of gaseous fuels through mains" },
        NACE_level_4: { code: "35.22", description: "Distribution of gaseous fuels through mains" },
        NACE_level_3: { code: "35.2", description: "Manufacture of gas, and distribution of gaseous fuels through mains" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.22", description: "Distribution of gaseous fuels through mains" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Independent Distribution Network Operators (IDNO)": {
        SCAT: { code: "742", description: "Independent Distribution Network Operators (IDNO)" },
        CPA: { code: "35.13", description: "Transmission services of electricity" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3513", description: "Electric power transmission and distribution activities" },
        NACE_level_4: { code: "35.13", description: "Transmission of electricity" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.13", description: "Distribution of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Renewable Power Generators - Photovoltaic": {
        SCAT: { code: "743", description: "Renewable Power Generators - Photovoltaic" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Renewable Power Generators – Wind": {
        SCAT: { code: "744", description: "Renewable Power Generators – Wind" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Renewable Power Generators – Other": {
        SCAT: { code: "745", description: "Renewable Power Generators – Other" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Renewable Power Generators - Hydro": {
        SCAT: { code: "746", description: "Renewable Power Generators - Hydro" },
        CPA: { code: "35.12", description: "Electricity from renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3512", description: "Electric power generation activities from renewable sources" },
        NACE_level_4: { code: "35.12", description: "Production of electricity from renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.12", description: "Transmission of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Fossil Fuel Power Stations": {
        SCAT: { code: "747", description: "Fossil Fuel Power Stations" },
        CPA: { code: "35.11", description: "Electricity from non-renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3511", description: "Electric power generation activities from non-renewable sources" },
        NACE_level_4: { code: "35.11", description: "Production of electricity from non-renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.11", description: "Production of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Nuclear Power Stations": {
        SCAT: { code: "748", description: "Nuclear Power Stations" },
        CPA: { code: "35.11", description: "Electricity from non-renewable sources" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3511", description: "Electric power generation activities from non-renewable sources" },
        NACE_level_4: { code: "35.11", description: "Production of electricity from non-renewable sources" },
        NACE_level_3: { code: "35.1", description: "Electric power generation, transmission and distribution" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.11", description: "Production of electricity" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Underground Gas Storage Facility": {
        SCAT: { code: "749", description: "Underground Gas Storage Facility" },
        CPA: { code: "35.22", description: "Distribution services of gaseous fuels through mains" },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3520", description: "Manufacture of gas; distribution of gaseous fuels through mains" },
        NACE_level_4: { code: "35.22", description: "Distribution of gaseous fuels through mains" },
        NACE_level_3: { code: "35.2", description: "Manufacture of gas, and distribution of gaseous fuels through mains" },
        NACE_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        UK_SIC: { code: "35.22", description: "Distribution of gaseous fuels through mains" },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "NHS Clinics & Health Centres (Contractors)": {
        SCAT: { code: "750", description: "NHS Clinics & Health Centres (Contractors)" },
        CPA: { code: "86.10", description: "Hospital services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8610", description: "Hospital activities" },
        NACE_level_4: { code: "86.10", description: "Hospital activities" },
        NACE_level_3: { code: "86.1", description: "Hospital activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.10", description: "Hospital activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "NHS Clinics & Health Centres (Rentals)": {
        SCAT: { code: "751", description: "NHS Clinics & Health Centres (Rentals)" },
        CPA: { code: "86.10", description: "Hospital services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8610", description: "Hospital activities" },
        NACE_level_4: { code: "86.10", description: "Hospital activities" },
        NACE_level_3: { code: "86.1", description: "Hospital activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.10", description: "Hospital activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Surgeries (Other Than GP/NHS) (Contractors)": {
        SCAT: { code: "752", description: "Surgeries (Other Than GP/NHS) (Contractors)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Surgeries (Other Than GP/NHS) (Rentals)": {
        SCAT: { code: "753", description: "Surgeries (Other Than GP/NHS) (Rentals)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "GP Surgeries (Contractors)": {
        SCAT: { code: "754", description: "GP Surgeries (Contractors)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "GP Surgeries (Rentals)": {
        SCAT: { code: "755", description: "GP Surgeries (Rentals)" },
        CPA: { code: "86.22", description: "Medical specialists services" },
        ISIC_level_1: { code: "R", description: "Human health and social work activities" },
        ISIC_level_4: { code: "8620", description: "Medical and dental practice activities" },
        NACE_level_4: { code: "86.22", description: "Medical specialists activities" },
        NACE_level_3: { code: "86.2", description: "Medical and dental practice activities" },
        NACE_level_1: { code: "R", description: "Human health and social work activities" },
        UK_SIC: { code: "86.22", description: "Specialist medical practice activities" },
        planning_classes: { code: "E(e)", description: "Provision of medical or health services (except the use of premises attached to the residence of the consultant or practitioner)" },
    },
    "Equestrian Hospitals": {
        SCAT: { code: "756", description: "Equestrian Hospitals" },
        CPA: { code: "75.00", description: "Veterinary services" },
        ISIC_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        ISIC_level_4: { code: "7500", description: "Veterinary activities" },
        NACE_level_4: { code: "75.00", description: "Veterinary activities" },
        NACE_level_3: { code: "75.0", description: "Veterinary activities" },
        NACE_level_1: { code: "N", description: "Professional, scientific and technical activities" },
        UK_SIC: { code: "75.00", description: "Veterinary activities" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Plant Nurseries": {
        SCAT: { code: "757", description: "Plant Nurseries" },
        CPA: { code: "01.30", description: "Planting material: live plants, bulbs, tubers and roots, cuttings and slips; mushroom spawn" },
        ISIC_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        ISIC_level_4: { code: "0130", description: "Plant propagation" },
        NACE_level_4: { code: "01.30", description: "Plant propagation" },
        NACE_level_3: { code: "01.3", description: "Plant propagation" },
        NACE_level_1: { code: "A", description: "Agriculture, forestry and fishing" },
        UK_SIC: { code: "01.30", description: "Plant propagation" },
        planning_classes: { code: "", description: "" },
    },
    "Commercial Miscellaneous": {
        SCAT: { code: "992", description: "Commercial Miscellaneous" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "T", description: "Other service activities" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_3: { code: "", description: "missing entry in classification" },
        NACE_level_1: { code: "", description: "missing entry in classification" },
        UK_SIC: { code: "", description: "missing entry in classification" },
        planning_classes: { code: "E(c)(iii)", description: "Other appropriate services in a commercial, business or service locality" },
    },
    "Leisure Miscellaneous": {
        SCAT: { code: "993", description: "Leisure Miscellaneous" },
        CPA: { code: "93.29", description: "Other amusement and recreation services" },
        ISIC_level_1: { code: "S", description: "Arts, sports and recreation" },
        ISIC_level_4: { code: "9329", description: "Other amusement and recreation activities" },
        NACE_level_4: { code: "93.29", description: "Amusement and recreation activities n.e.c." },
        NACE_level_3: { code: "93.2", description: "Amusement and recreation activities" },
        NACE_level_1: { code: "S", description: "Arts, sports and recreation" },
        UK_SIC: { code: "93.29", description: "Other amusement and recreation activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Industrial Miscellaneous": {
        SCAT: { code: "994", description: "Industrial Miscellaneous" },
        CPA: { code: "32.99", description: "Other manufactured goods n.e.c." },
        ISIC_level_1: { code: "D", description: "Electricity, gas, steam and air conditioning supply" },
        ISIC_level_4: { code: "3290", description: "Other manufacturing n.e.c." },
        NACE_level_4: { code: "32.99", description: "Other manufacturing n.e.c." },
        NACE_level_3: { code: "32.9", description: "Manufacturing not elsewhere classified" },
        NACE_level_1: { code: "C", description: "Manufacturing" },
        UK_SIC: { code: "32.99", description: "Other manufacturing n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Educational Miscellaneous": {
        SCAT: { code: "995", description: "Educational Miscellaneous" },
        CPA: { code: "85.59", description: "Other education services n.e.c." },
        ISIC_level_1: { code: "Q", description: "Education" },
        ISIC_level_4: { code: "8559", description: "Other education n.e.c." },
        NACE_level_4: { code: "85.59", description: "Other education n.e.c." },
        NACE_level_3: { code: "85.5", description: "Other education" },
        NACE_level_1: { code: "Q", description: "Education" },
        UK_SIC: { code: "85.59", description: "Other education n.e.c." },
        planning_classes: { code: "F1(a)", description: "Provision of education" },
    },
    "Formula Assessed Miscellaneous": {
        SCAT: { code: "996", description: "Formula Assessed Miscellaneous" },
        CPA: { code: "", description: "missing entry in classification" },
        ISIC_level_1: { code: "C", description: "Manufacturing" },
        ISIC_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_4: { code: "", description: "missing entry in classification" },
        NACE_level_3: { code: "", description: "missing entry in classification" },
        NACE_level_1: { code: "", description: "missing entry in classification" },
        UK_SIC: { code: "", description: "missing entry in classification" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Minerals Miscellaneous": {
        SCAT: { code: "997", description: "Minerals Miscellaneous" },
        CPA: { code: "08.99", description: "Other mining and quarrying products n.e.c." },
        ISIC_level_1: { code: "B", description: "Mining and quarrying" },
        ISIC_level_4: { code: "0899", description: "Other mining and quarrying n.e.c." },
        NACE_level_4: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        NACE_level_3: { code: "08.9", description: "Mining and quarrying not elsewhere classified" },
        NACE_level_1: { code: "B", description: "Mining and quarrying" },
        UK_SIC: { code: "08.99", description: "Other mining and quarrying n.e.c." },
        planning_classes: { code: "E(g)(iii)", description: "Industrial processes" },
    },
    "Crown Miscellaneous": {
        SCAT: { code: "998", description: "Crown Miscellaneous" },
        CPA: { code: "84.11", description: "General public administration services" },
        ISIC_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        ISIC_level_4: { code: "8411", description: "General public administration activities" },
        NACE_level_4: { code: "84.11", description: "General public administration activities" },
        NACE_level_3: { code: "84.1", description: "Administration of the State and the economic, social and environmental policies of the community" },
        NACE_level_1: { code: "P", description: "Public administration and defence; compulsory social security" },
        UK_SIC: { code: "84.11", description: "General public administration activities" },
        planning_classes: { code: "Sui generis", description: "" },
    },
    "Miscellaneous": {
        SCAT: { code: "999", description: "Miscellaneous" },
        CPA: { code: "96.99", description: "Other personal services n.e.c." },
        ISIC_level_1: { code: "T", description: "Other services activities" },
        ISIC_level_4: { code: "9690", description: "Other personal service activities n.e.c." },
        NACE_level_4: { code: "96.99", description: "Other personal service activities n.e.c." },
        NACE_level_3: { code: "96.9", description: "Other personal service activities" },
        NACE_level_1: { code: "T", description: "Other services activities" },
        UK_SIC: { code: "96.09", description: "Other personal service activities n.e.c." },
        planning_classes: { code: "Sui generis", description: "" },
    },
};
export default landuseCodesData;
